(function() {
  "use strict";

  angular.module("sempraWebapp").constant("deTranslations", {
    MESSAGE:"Nachricht",
    ERROR_TITLE:"Fehler",
    ERROR_MESSAGE:"Ein Fehler ist während der Ausführung aufgetreten.",
    ERROR_LOGIN:"Es ist ein Fehler beim Log-In aufgetreten. Die angegebene E-Mail-Adresse ist ungültig. Bitte versuchen Sie es erneut.",
    ERROR_LOGIN_ROLE:"Die ausgewählte Rolle ist für die angegebene Person nicht freigeschaltet",
    OK:"Ok",
    CANCEL:"Abbrechen",
    YES:"Ja",
    NO:"Nein",
    UNLIMITED:"Unbegrenzt",
    FROM:"Von",
    TO:"Bis",
    DELETE:"Löschen",
    SIGN_OUT:"Abmelden",
    NAME:"Name",
    DATE:"Datum/Uhrzeit",
    PIECES:"Stücke",
    HOURS:"Stunden",
    DAYS:"Tage",
    MONTH:"Monat",
    MONTHS:"Monate",
    YEAR:"Jahr",
    BOX:"Box",
    SEARCH:"Suche",
    ALL_USERS:"Alle Benutzer",
    ARE_YOU_SURE:"Sind Sie sicher?",
    BACK:"Zurück",
    AMOUNT:"Menge",
    DESCRIPTION:"Beschreibung",
    FORGOT_PASSWORD_ERROR_MSG:"Es ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre E-Mail-Adresse und versuchen Sie es erneut.",
    REQUIRED_FIELD:"Das Feld ist erfolderlich",
    LOGOUT_TITLE:"Sind Sie sicher, dass Sie sich abmelden möchten?",
    LOGOUT_MSG:"All ihre ungespeicherten Daten gehen verloren.",
    ACTIVATION_ACCOUNT:"Sie haben Ihr Konto erfolgreich aktiviert",
    UNKNOWN_ERRROR_NOTIFICATION:"Es ist ein unbekannter Fehler aufgetreten",
    CONTINUE:"Weiter",
    DATA_NOT_AVAILABLE:"Keine Daten verfügbar",
    SELECT:"Auswählen",
    SELECT_CURRENCY:"Währung auswählen",
    UPLOAD:"Hochladen",
    PHONE:"Telefonnummer",
    WEBSITE:"Website",
    WORKING_HOURS:"Öffnungszeiten",
    INSERT:"Einfügen",
    TEXT:"Text",
    CREATED:"Erstellt",
    VALID_UNTIL:"Gültig bis",
    SAVE:"Speichern",
    TOKENS:"Wertmarken",
    DELETE_COMPANY_HISTORY:"Waschanlagenverlauf dauerhaft löschen?",
    DELETE_COMPANY_HISTORY_MESSAGE:"ACHTUNG: Nach Bestätigung werden alle Transaktionen Ihrer Waschanlage unwiderruflich gelöscht!",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Sind Sie sicher, dass Sie alle Transaktionsdaten unwiderruflich löschen möchten?",
    HISTORY_SUCCESSFULY_DELETED:"Verlauf erfolgreich gelöscht",
    HELP:"Hilfe",
    VALUE:"Wert",
    ACTIVATING_ACCOUNT_ERROR:"Ein Fehler ist während der Aktivierung Ihres R2W Kontos aufgetreten. Bitte versuchen Sie es erneut. Falls das Problem weiterhin besteht, wenden Sie sich bitte an support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Herzlich willkommen bei Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Herzlich willkommen bei R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Bitte geben Sie Ihr neues Passwort ein und bestätigen Sie es, um Ihr R2W-Konto zu aktivieren. Bei Erfolg werden Sie automatisch bei der Anwendung angemeldet.",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Sie können Ihre Benutzereinstellungen später in der Anwendung ändern",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Willkommen bei Kärcher Vehicle Wash",
    RESET_PASSWORD_WELCOME_MSG:"Ready2Wash Car Wash",
    RESET_PASSWORD_WELCOME_MSG_2:"Um ihr altes Passwort zu ersetzen geben Sie bitte ihr neues Passwort ein und bestätigen Sie dieses. Bei Erfolg werden Sie automatisch angemeldet.",
    RESET_PASSWORD_WELCOME_MSG_3:"Sie können ihre Profileinstellungen später in der Anwendung anpassen",
    ENTER_NEW_PASSWORD:"Geben Sie ein neues Passwort ein",
    REPEAT_NEW_PASSWORD:"Neues Passwort wiederholen",
    PASSWORD_MIN_LENGTH:"Das Passwort muss mindestens 8 Zeichen lang sein",
    PASSWORD_MAX_LENGHT:"Das Passwort darf nicht mehr als 32 Zeichen lang sein",
    PASSWORD_PATTERN:"Das Passwort muss mindestens einen großen und einen kleinen Buchstaben enthalten",
    PASSWORD_MATCH:"Die Passwörter sind nicht identisch",
    ACTIVATE:"Aktivieren",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Sie haben die Anfrage erfolgreich gesendet. Bitte überprüfen Sie ihr Postfach auf eine Bestätigungsnachricht",
    VALIDATION_REQUIRED:"Pflichtfeld",
    VALIDATION_EMAIL:"Falsche E-Mail-Adresse",
    VALIDATION_INTEGER_NUMBER:"Der Wert muss eine Zahl sein",
    VALIDATION_HOURS_VALUE:"Der Wert muss zwischen 0-23 sein",
    VALIDATION_MINUTES_VALUE:"Der Wert muss zwischen 0-59 sein",
    VALIDATION_NOT_A_DATE:"Der eingegebene Wert ist kein Datum",
    VALIDATION_FROM:"Das eingegebene Datum muss vor dem Enddatum liegen",
    VALIDATION_TO:"Das eingegebene Datum muss nach dem Sartdatum liegen",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Diese Informationen geben es bereits in der Datenbank",
    PASSWORD_VALIDATION_PATTERN_NEW:"Das Passwort muss mindestens einen Großbuchstaben und eine Zahl enthalten. Leerzeichen sind nicht erlaubt.",
    VALIDATION_PERCENT_VALUE:"Der Wert muss zwischen 1-999 sein",
    NUMBERS_ONLY_100:"Der Wert muss unter 100 liegen",
    NUMBERS_ONLY_1000:"Der Wert muss unter 1000 liegen",
    POSITIVE_NUMBERS_ONLY:"Nur positive Zahl",
    GRID_PAGER_PAGE:"Seite",
    GRID_PAGER_ROWS_PER_PAGE:"Zeilen pro Seite",
    GRID_PAGER_PAGE_OF:"Von",
    BREAD_CRUMBS_HOME:"Startseite",
    BREAD_CRUMBS_DASHBOARD_TECH:"Überblick der Waschanlagen",
    BREAD_CRUMBS_DETAILS:"Details",
    BREAD_CRUMBS_SETTINGS:"Einstellungen",
    BREAD_CRUMBS_WORKING_HOURS:"Öffnungszeiten",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Gesamtumsatz pro Tag",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Durchschnittlicher Umsatz pro Stunde",
    BREAD_CRUMBS_NEW_USER_GROUP:"Kundengruppe erstellen",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Benutzergruppe ändern",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Bonusprogramm-Vorlage erstellen",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Bonusprogramm-Vorlage bearbeiten",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Bonusprogramm erstellen",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Bonusprogramm bearbeiten",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Rechnungsübersicht",
    LOGIN:"Anmeldung",
    EMAIL:"E-Mail",
    PASSWORD:"Passwort",
    LANGUAGE:"Sprache",
    FORGOT_PASSWORD:"Passwort vergessen?",
    SUBMIT:"Bestätigen",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Anzahl der aktuellen kritischen Fehler:",
    HEADER_VIEW_ALL_ALARMS:"Alle Fehlermeldungen betrachten...",
    HEADER_MY_ACCOUNT:"Mein Konto",
    HEADER_ACCOUNT_MANAGEMENT:"Kontoverwaltung",
    ACCOUNT_ALREADY_EXIST:"Diese E-Mail-Adresse ist bereits in Verwendung",
    NEWSLETTER_CONFIRMATION:"Benachrichtigung per E-Mail bei Fehlermeldungen",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Umsätze",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Übersicht Waschanlagen",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Übersicht",
    ASIDE_MENU_ALARMS:"Übersicht Fehlermeldungen",
    ASIDE_MENU_FACILITIES:"Waschanlagen",
    ASIDE_MENU_REPORTS:"Reports",
    ASIDE_MENU_REPORT:"Ausgewählter Bericht",
    ASIDE_MENU_LOYALTY:"Bonusprogramm",
    ASIDE_MENU_USER_GROUPS:"Kundengruppen",
    ASIDE_MENU_PERIODIC_SUMMARY:"Rechnungsübersicht",
    ASIDE_MENU_MANAGING_TOKENS:"Wertmarken verwalten",
    ASIDE_MENU_NEWS:"Neuigkeiten",
    DAILY_FINANCES_TOTAL_MONEY:"Gesamtumsatz",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Gesamtumsatz aller Anlagen",
    DAILY_FINANCES_TOTAL_COINS:"Insgesamt verwendete Metall-Token",
    DAILY_FINANCES_DOWNLOAD_CSV:"CSV herunterladen",
    DAILY_FINANCES_ONLINE:"Online",
    DAILY_FINANCES_OFFLINE:"Bargeld",
    DAILY_FINANCES_CHANGER:"Wechselautomat Bargeld",
    DAILY_FINANCES_COINS:"Wertmarken",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Art des Reports",
    REPORTS_CHOOSE_FACILITY:"Stationsauswahl",
    REPORTS_PERIOD_1:"Periode 1 - ",
    REPORTS_PERIOD_2:"Periode 2 - ",
    MONEY_BY_DATE_REPORT:"Gesamtumsatz pro Tag",
    R2W_BY_DATE_REPORT:"Online - Zahlungen pro Tag gesamt",
    COINS_BY_DATE_REPORT:"Wertmarken pro Tag gesamt",
    AVG_MONEY_BY_HOUR_REPORT:"Durchschnittlicher Umsatz pro Stunde",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Durchschnittlicher Umsatz pro Tag",
    AVG_MONEY_BY_BOX_REPORT:"Durchschnittlicher Umsatz pro Waschbox",
    COMPARE_PERIODS_REPORT:"Umsatzbericht im Zeitraum",
    TOTAL_USERS_BY_GROUP:"Nutzer pro Tag gesamt",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"Benutzer",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"Besuche",
    VISITS_COUNT_REPORT:"Anzahl der Besuche pro Tag",
    LOYALTY_PER_DAY_REPORT:"Anzahl der pro Tag ausgegebenen lokalen Wertmarken",
    LOYALTY_PER_PAYMENT_METHOD:"Gegebene lokale Wertmarken pro Zahlungsmethode",
    VISITS:"Besuche",
    VISIT:"Besuch",
    TOTAL_SPENT_MONEY:"Gesamtumsatz",
    MONEY:"Geld",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Gesamtumsatz für den Zeitraum",
    DOWNLOAD_CSV:"CSV herunterladen",
    TOTAL_SPENT_COINS:"Gesamtanzahl Token im Umlauf",
    TOTAL_USERS:"Benutzer insgesamt",
    TOTAL_CREDIT_GIVEN:"Wertmarken im Umlauf",
    EUROKEY_BY_DATE_REPORT:"Die Gesamtzahlungen von Euro-Taste",
    TOTAL_SPENT_EUROKEY:"Insgesamt verbracht",
    SELECT_TYPE_OF_REPORT:"Bitte wählen Sie den Typ des Berichts aus",
    NUMBER_OF_VISITS_TITLE:"Anzahl der Besuche",
    NUMBER_OF_USERS_TITLE:"Anzahl der Nutzer",
    PIECES_TITLE:"Stücke",
    TOTAL_VISITS:"Besuche insgesamt",
    TOKENS_TITLE:"Wertmarken",
    SEARCH_USERS_NO_RESULTS:"Keine Kunden für festgelegtes Suchkriterium gefunden",
    SEARCH_USERS:"Kunden suchen",
    SEARCH_TELEPHONES:"Kundensuche über Handynummer",
    ADD_USER_TO_GROUP:"Kunde durch E-Mail-Adresse zu der Gruppe hinzufügen",
    REMOVE_USER_FROM_GROUP:"Kunden aus der Gruppe entfernen",
    USER_GROUP_NAME_REQUIRED:"Ein Name für die Kundengruppe wird benötigt",
    USER_GROUP_NAME:"Name der Kundengruppe",
    USER_GROUPS_OVERVIEW:"Übersicht der Kundengruppen",
    USER_COUNT:"Kundenanzahl",
    NEW_USER_GROUP:"Erstellen Sie eine neue Kundengruppe",
    DELETE_USER_GROUP:"Kundengruppe löschen",
    UPDATE_USER_GROUP:"Kundengruppe bearbeiten",
    DELETE_USER_GROUP_ERROR:"Ein Fehler ist während der Löschung der ausgewählten Kundengruppe aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den technischen Support ...",
    CONFIRM_DELETE_USER_GROUP:"Sind Sie sicher, dass Sie die ausgewählte Kundengruppe löschen möchten?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Sonderangebote, denen die Gruppe zugeteilt wurde, werden nicht mehr aktiv sein.",
    GROUP_NAME_MAX_LENGTH:"Der Gruppenname muss weniger als 255 Zeichen haben.",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Der Kunde ist schon in dieser Gruppe.",
    MISSING_USER:"Kunde nicht gefunden",
    USER_NOT_ON_LIST:"Die von Ihnen eingegebene E-Mail-Adresse ist entweder nicht korrekt oder der Kunde ist noch nicht in der Kundenstammliste hinterlegt. Bitte überprüfen Sie die eingegebene E-Mail-Adresse und versuchen Sie es erneut.",
    UPLOAD_USER_GROUP:"Bitte laden Sie die Liste der Kundengruppe aus der CSV-Datei hoch",
    UKNOWN_USERS:"Liste der unbekannten Kunden",
    CAMPAIGN_TEMPLATE_RULE:"Vorlage Regeln Bonusprogramm",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Ein Fehler ist während der Löschung der ausgewählten Bonusprogramm-Vorlage aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den technischen Support...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Sind Sie sicher, dass Sie die ausgewählte Bonusprogramm-Vorlage löschen möchten?",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Sind Sie sicher, dass Sie die ausgewählte Bonusprogramm-Vorlage löschen möchten?",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Übersicht der Bonusprogramm-Vorlagen",
    DELETE_CAMPAIGN_TEMPLATE:"Bonusprogramm-Vorlage löschen",
    UPDATE_CAMPAIGN_TEMPLATE:"Bonusprogramm-Vorlage ändern",
    CREATE_CAMPAIGN_TEMPLATE:"Bonusprogramm-Vorlage erstellen",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Es wird ein Name für die Vorlage des Bonusprogramms benötigt",
    CAMPAIGN_TEMPLATE_NAME:"Name der Bonusprogramm-Vorlage",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Pflichtfeld",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"Rabatt in %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"Extra Zeit",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Bitte wählen Sie zuerst den Typ. Waschboxen oder kleine Maschinen.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Vorlage löschen",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Von",
    CAMPAIGN_TEMPLATE_RULE_TO:"Bis",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"Stunden",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"Minuten",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Neue Regel erstellen: Bonusmarken durch häufuge Besuche",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Neue Regel erstellen: Bonusmarken durch hohen Umsatz",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Neue Regel bezüglich der Wochentage",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Die neue Regel hinzufügen",
    CAMPAIGN_TEMPLATE_RULE_1:"Bei",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Bei Ausgabe von",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"Wertmarken innerhalb von",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"besuchen in weniger als",
    CAMPAIGN_TEMPLATE_RULE_3:"Tagen bekommt der Kunde",
    CAMPAIGN_TEMPLATE_RULE_4:"Wertmarken",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Die Regelliste ist leer.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Datum kann nicht in der Vergangenheit sein",
    DELETE_CAMPAIGN_ERROR:"Ein Fehler ist während der Löschung der ausgewählten Bonusprogramms aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den technischen Support...",
    CONFIRM_DELETE_CAMPAIGN:"Sind Sie sicher, dass Sie das ausgewählte Bonusprogramm löschen möchten?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"Möchten Sie den ausgewählten Bonusprogramm-Text wirklich löschen?",
    CAMPAIGNS_OVERVIEW:"Bonusprogramm bearbeiten",
    DELETE_CAMPAIGN:"Bonusprogramm löschen",
    UPDATE_CAMPAIGN:"Bonusprogramm ändern",
    CREATE_CAMPAIGN:"Neues Bonusprogramm erstellen",
    CAMPAIGN_ACTIVE:"Aktiv",
    CAMPAIGN_TEMPLATE:"Vorlage",
    CAMPAIGN_GROUPS:"Gruppen",
    CAMPAIGN_ALL_USERS:"Alle Benutzer",
    CAMPAIGN_NAME:"Name des Bonusprogramms",
    CAMPAIGN_NAME_REQUIRED:"Es wird ein Name für das Bonusprogramm benötigt",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Kunden welche nah am Tageslimit sind",
    MESSAGE_TO_USERS:"Nachricht an die gefilterten Kunden",
    SEND_MESSAGE:"Nachricht senden",
    THRESHOLD:"Limit",
    TYPE:"Typ",
    TOTAL_MONEY_SPENT:"Insgesamt ausgegebenes Geld während dieses Bonusprogramms",
    NUMBER_OF_VISITS:"Besuche während des Bonusprogramms",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Die Nachricht muss mindestens 10 Zeichen lang sein",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Die Nachricht darf nicht mehr als 350 Zeichen haben ",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Ein Text ist erforderlich",
    TECHNOLOGY:"Technologie",
    TAP_WATER:"Stadtwasser",
    REVERSE_OSMOSIS:"Umkehrosmose",
    SOFTENED_WATER:"Weichwasser",
    DOSER:"Dosierer",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Letzte Synchronisierung",
    NO_OF_CURRENT_ALARMS:"Anzahl der aktuellen Fehlermeldungen",
    NO_OF_CURRENT_WARNINGS:"Anzahl der aktuellen Warnungen",
    WEATHER:"Wetter",
    BOXES_WORK_HOURS_COUNTERS:"Arbeitsstundenzähler der Waschboxen",
    BOX_TOTAL_HOURS:"Gesamtstunden aller Waschboxenzähler",
    BOX_SERVICE_HOURS:"Stundenzähler Service",
    BOX_COUNTER_HOURS:"Stunden",
    ALARMS_AND_WARNINGS:"Alarme und Warnungen",
    FILTER_AND_BOILER:"Filter und Boiler",
    FILTER_TOTAL_DAYS:"Stundenzähler Filter",
    BOILER_TOTAL_DAYS:"Stundenzähler Boilers",
    DAYS_UNIT:"Tage",
    SOFTENER:"Weichmacher",
    MANUAL_COLD_DRAIN:"Kaltwasserabfluss manuell",
    EL_COLD:"El. Winter",
    DRAIN:"Abfluss",
    TAP:"Wasserhahn",
    WASTE:"Abfall",
    OSMOSIS:"Osmose",
    DEMI_WATER:"demineralisiertes Wasser",
    EL_RINSE:"El. m. Spülung",
    BOILER:"Boiler",
    EL_WAX:"El. m. Vachs",
    FLOOR_HEATING:"Fußbodenheizung",
    DOSER_TANK:"Dosiertank",
    EL_WASH:"El. m. Waschen",
    DETERGENT:"Reinigungsmittel",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Einstellungen aktualisieren",
    GENERAL_SETTINGS:"Allgemeine Einstellungen",
    LIGHTS:"Licht",
    GROUPS:"Gruppen",
    ANTI_FREEZE:"Frostschutz",
    AUTO:"Auto",
    MANUAL:"Manuell",
    ON:"Ein",
    OFF:"Aus",
    TEMPERATURE:"Temperatur",
    UPDATE_DEVICE:"Waschanlagen Einstellungen aktualisieren",
    BOX_CLEAN_HOURS:"Stundenzähler Waschbox",
    GROUP_COUNTERS:"Gruppenzähler",
    RESET:"zurücksetzen",
    CASH_COUNT:"Münzzähler",
    COINS_COUNT:"Wertmarkenzähler",
    EUROKEY_COUNT:"Eurokeyzähler",
    DOSER_WORK:"Zähler Dosierer (Sek.)",
    DOSER_PAUSE:"Zähler Pausezeit Dosierer (Sek.)",
    DELAY_BFV:"BFV Verspätung (ms)",
    DELAY_6M1:"6M1 Verspätung (ms)",
    DELAY_LPS:"LPS Verspätung (ms)",
    RESET_CASH_COUNT_ALL:"Alle Münzzähler zurücksetzen",
    RESET_COINS_COUNT_ALL:"Alle Wertmarkenzähler zurücksetzen",
    RESET_EUROKEY_COUNT_ALL:"Alle Eurokeyzähler zurücksetzen",
    FACILITY_DETAILS:"Anlagendetails",
    FACILITY_NAME:"Anlagentyp",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Sie haben erfolgreich ein Bild hochgeladen",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Sie haben erfolgreich Angaben geändert",
    CONNECTED:"Verbunden",
    DISCONNECTED:"Getrennt",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Nachrichtenfilter",
    FACILITY:"Waschanlage",
    APPLY:"Anwenden",
    TIME:"Zeit",
    LOCATION:"Standort",
    ACKNOWLEDGED:"Bemerkt",
    FILTERED_MESSAGES:"gefilterte Nachrichten",
    ACK:"entdeckt",
    NOT_ACK:"Unentdeckt",
    ALL:"Alle",
    ALL_FACILITIES:"Alle Waschanlagen",
    ENTER_DATE_PLACEHOLDER:"Datum eingeben",
    OP_NESTANAK_NAPONA:"Netzausfall Fehler - 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Hochdruckpumpe - Fehler Motorschutzschalter",
    OP_UPR_NAPON_24VAC_GRE:"Steuerspannung 24VAC Fehler -5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Frischwassertank - Trockenlaufschutz",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Hauptpumpe - Fehler Motorschutzschalter",
    OP_MIN_NIVO_OMEKS_VODE:"Weichwassertank - Trockenlaufschutz",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Weichwasserpumpe - Fehler Motorschutzschalter",
    OP_MIN_NIVO_DEMIN_VODE:"Osmosewasser Tank - Trockenlaufschutz",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Osmosewasser Pumpe - Fehler Motorschutzschalter",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Umkehrosmose Pumpe - Fehler Motorschutzschalter",
    OP_BOJLER_GRESKA_MZS:"Boiler Fehler",
    OP_CRPKA_PRASKA_GRE_MZS:"Heißwasserpumpe - Fehler Motorschutzschalter",
    OP_DOZATOR_PRASKA_GRE_MZS:"Schaumdosierer - Fehler Motorschutzschalter",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Dosierpumpe Schaum - Fehler Schutzschalter",
    OP_MIN_PRASAK_TON_ALARM:"Pulvermischbehälter leer",
    OP_USIS_KOV_TURBINA_GRESKA:"Staubsaugerturbine - Fehler Motorschutzschalter",
    OP_FILTER_VODE_ZACEPLJEN:"Wasserfilter verstopft",
    OP_VISKTL_RESET_SATI_RADA:"Service Hochdruckpumpe",
    OPW_VISKTL_RESET_SATI_RADA:"Service Hochdruckpumpe",
    OP_FILTER_DANI_RADA:"Fehler Wasserfilter",
    OP_BOJLER_DANI_RADA:"Fehler Boiler",
    OPW_ALARM_VISOKOTL_PUMPA:"Fehlermeldung Hochdruckpumpe",
    OPW_ALARM_FILTER_SERVIS:"Servicealarm Filter",
    OPW_ALARM_BOJLER_SERVIS:"Servicealarm Boiler",
    HAS_MEMBERS:"Die ausgewählte Gruppe hat Mitglieder und kann somit nicht gelöscht werden. Bitte löschen Sie zuerst alle Mitglieder.",
    PERIODIC_SUMMARY_FOR:"periodischer Bericht für",
    PERIODIC_SUMMARY_REPORTS:"periodischer Bericht",
    DATE_RANGE:"Zeitraum",
    FINANCIAL_REPORT:"Finanzbericht",
    GROSS_INCOME:"Bruttoumsatz",
    GROSS_INCOME_SUM:"Summe Bruttoumsatz",
    COMMISSION_FEE:"Provisionsgebühr",
    NET_INCOME:"Nettoumsatz",
    COMMISSION_FEE_DETAILS:"Die Provisionsgebühren beinhalten die Gebühren der Bank, von PayPal und die Bereitstellungsgebühr von SMS",
    LOYALTY_CREDITS_REPORT:"Wertmarken-Bericht",
    LOYALTY_GIVEN:"Wertmarken aus Bonusprogrammen",
    LOYALTY_USED:"Verwendete Wertmarken",
    LOYALTY_SOLD:"Wertmarken im Umlauf",
    LOYALTY_TOTAL:"Insgesamt",
    LOYALTY_CURRENT_MONTH:"Aktueller Monat",
    SOMETHING_WENT_WRONG:"Es ist ein Fehler aufgetreten",
    MISSING_PAGE:"Tut uns leid. Wir konnten die Seite nicht laden.",
    TRY_AGAIN:"versuchen Sie es erneut",
    DEFAULT_ERROR_NAME:"Es ist ein unbekannter Fehler aufgetreten",
    DEFAULT_ERROR_DESCRIPTION:"Bitte versuchen Sie es erneut.",
    MY_ACCOUNT_DETAILS:"Meine Profildetails",
    SAVE_CHANGES:"Änderungen speichern",
    USERNAME:"E-Mail-Adresse des Kunden",
    FIRST_NAME:"Name",
    LAST_NAME:"Nachname",
    USER_ROLE:"Kundengruppe",
    OLD_PASSWORD:"Das alte Passwort",
    NEW_PASSWORD:"Das neue Passwort",
    OLD_PASSWORD_REQUIRED:"Das alte Passwortfeld ist erfolderlich",
    NEW_PASSWORD_REQUIRED:"Das neue Passwortfeld ist erforderlich",
    NEW_PASSWORD_REPEAT:"Es ist erforderlich, dass Sie das neue Passwort wiederholen",
    NEW_PASSWORD_NOT_MATCH:"Das alte und neue Passwort sind nicht identisch",
    PASSWORD_DIFFERENT_VALIDATION:"Das neue Passwort muss sich von dem alten unterscheiden",
    PASSWORD_MIN_CHAR:"Das Passwort muss mindestens 8 Zeichen enthalten",
    PASSWORD_MAX_CHAR:"Das Passwort darf nur maximal 32 Zeichen enthalten",
    PASSWORD_PATTERN_VALIDATION:"Das Passwort muss mindestens eine Ziffer enthalten",
    ACCOUNT_MANAGEMENT:"Profilverwaltung",
    NOT_ACTIVE:"Inaktiv",
    ASSIGN_ROLE:"Benutzergruppe",
    UPDATE:"Aktualisieren",
    ADD_NEW_ACCOUNT:"Einen neuen Benutzer hinzufügen",
    EMAIL_REQUIRED:"E-Mail-Adresse ist erforderlich",
    EMAIL_NOT_VALID:"Diese E-Mail-Adresse ist ungültig",
    ADD_NEW_USER_TEXT:"Email mit einem Aktivierungslink wird an diese Adresse gesendet",
    UPDATE_USER_NOTIFICATION:"Sie haben Ihre Informationen erfolgreich aktualisiert",
    CHANGED_PASSWORD_NOTIFICATION:"Sie haben Ihr Passwort erfolgreich geändert",
    UPDATE_USER_GROUP_NOTIFICATION:"Sie haben den Gruppennamen erfolgreich geändert",
    CREATE_USER_GROUP_NOTIFICATION:"Sie haben erfolgreich eine Gruppe erstellt",
    DETELE_USER_GROUP_NOTIFICATION:"Sie haben erfolgreich die Gruppe gelöscht",
    EMPTY_GROUP_LIST_MSG:"Es gibt noch keine Gruppen. Um zu beginnen, erstellen Sie eine",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Sie haben erfolgreich den Benutzer aus der Gruppe gelöscht",
    ADD_USER_TO_GROUP_NOTIFICATION:"Sie haben erfolgreich einen Benutzer zu einer Gruppe hinzugefügt",
    ADD_USER_NOTIFICATION:"Sie haben erfolgreich einen neuen Benutzer hinzugefügt.",
    DELETE_USER_NOTIFICATION:"Sie haben erfolgreich den Benutzer gelöscht.",
    RESEND_USER_VERIFICATION_EMAIL:"Sie haben erfolgreich die Autorisierungs-Mail erneut gesendet",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Um eine Kundengruppe zu erstellen, geben Sie bitte deren Namen ein",
    DELETE_USER:"Benutzer löschen",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Sind Sie sicher, dass Sie den Benutzer aus der Gruppe löschen möchten?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Sehr geehrte, wenn Sie uns während der Kampagne in diesem Monat besuchen, werden Sie einen Extrabonus auf Ihr Konto bekommen.",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Bonusmarken durch häufige Besuche",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Bonusmarken durch hohen Umsatz",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Regel bezüglich der Wochentage",
    REMOVE_CAMPAIGN_RULE_TITLE:"Diese Regel löschen",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Sind Sie sicher, dass Sie die Regel aus dem Bonusprogramm löschen möchten?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Sie haben erfolgreich ein neues Bonusprogramm erstellt",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Sie haben das Bonusprogramm erfolgreich aktiviert",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Es gibt noch keine gespeicherten Bonusprogramme. Um zu beginnen, müssen Sie eines erstellen.",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Sie haben die Nachricht erfolgreich versendet.",
    COMPANY_ACCOUNTS:"Firmenkontos",
    BUSSINESS_INVOICES_LIST:"Meine B2B Rechnungen",
    LOCALE_TOKEN:"Lokale Wertmarke",
    R2W:"Globale Wertmarke",
    START_MONTH:"Startmonat",
    END_MONTH:"Endmonat",
    TOKEN_TYPE:"Wertmarke Typ",
    TOKEN_NUMBER:"Anzahl der Wertmarken",
    NOTHING_TO_DISPLAY:"* Keine Anzeige",
    CREATE_INVOICE:"Rechnung erstellen",
    INVOICE:"Rechnung",
    INVOICES:"Rechnungen",
    EDIT_INVOICE:"Rechnung bearbeiten",
    UPDATE_INVOICE_NOTIFICATION:"Sie haben erfolgreich den Status der Rechnung in „ausstehend“ geändert",
    CURRENT_CHARGES:"Gebühren für den aktuellen Zeitraum",
    PAYMENTS_ON_HOLD:"Rechnungen in Bearbeitung",
    FOR_INVOICING:"Noch nicht in Rechnung gestellt",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Sie sind gerade dabei die Rechnung zu stornieren",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Sind Sie sicher, dass Sie die Rechnung stornieren möchten ?",
    INVOICING_NOTIFICATION_HEADER:"Sie sind gerade dabei eine Rechnung zu versenden",
    INVOICING_NOTIFICATION_TEXT:"Sind Sie sicher, dass Sie eine Rechnung schicken möchten?",
    SENT_INVOICE_NOTIFICATION:"Sie haben erfolgreich eine Rechnung gesendet",
    CANCELED_INVOICE_NOTIFICATION:"Sie haben erfolgreich die Rechnung storniert",
    INVOICE_DESCRIPTION_TEXT:"Rechnung für",
    INVOICE_STATE:"Status der Rechnung",
    INVOICE_NUMBER:"Rechnungsnummer",
    INVOICE_TOTAL:"Insgesamt",
    SELECT_YEAR:"Wählen Sie das Jahr",
    DOWNLOAD:"PDF herunterladen",
    INVOICE_NUMBER_HEADER:"Sie beabsichtigen die Rechnung mit folgender Nummer zu versenden:",
    INVOICE_PAYMENT_CONFIRMATION:"Sie beabsichtigen, folgende Zahlung zu bestätigen:",
    INSERT_INVOICE_NUMBER:"Rechnungsnummer eintragen",
    INVOICED_WARNING:"Die E-Mail wurde nicht gesendet. Bitte warten ...",
    SEND_INVOICE:"Senden",
    INVOICE_ALL:"Alle",
    INVOICE_FROM_R2W:"Von R2W",
    INVOICE_TO_R2W:"An R2W",
    PAYMENT_REQUEST:"Zahlungsaufforderung",
    PAYMENT_REQUEST_STATE:"Status der Zahlungsaufforderung",
    PAYMENT_REQUEST_NUMBER:"Nummer der Zahlungsaufforderung",
    FOR_PAYMENT_REQUEST:"Für Zahlungsaufforderungen",
    PAYMENT_REQUEST_ON_HOLD:"Zahlungsaufforderungen in Bearbeitung",
    DOWNLOAD_INVOICE:"Rechnung herunterladen",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Klicken Sie hier für die Optionen zum Herunterladen",
    B2B_SPEC:"B2B - Angaben",
    B2C_SPEC:"B2C - Angaben",
    DOWNLOAD_PAYMENT_REQUEST:"Zahlungsaufforderung herunterladen",
    LOYALTY_PREVIEW:"Übersicht Bonusprogramm",
    ACTIVATED:"Aktiviert",
    RUNNING:"Laufend",
    NOT_ACTIVATED:"Nicht aktiviert",
    FINISHED:"Fertig",
    DEPRECATED:"Veraltet",
    UPCOMING:"Kommend",
    NONE:"individuell",
    STARTED:"Gestartet",
    ENDS:"Endet",
    DEDICATED:"Profiteure",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Sie sind dabei folgendes zu aktivieren:",
    CAMPAIGN:"Treueprogramm",
    SEND_MESSAGE_NOTIFICATION:"Sie sind dabei eine Nachricht an die ausgewählte(n) Kundengruppe(n) zu senden",
    DIVISIBLE_TO_NUMBER:"Die Zahl sollte teilbar sein durch",
    BRIDGE_PLC:"PLC - Brücke",
    DEVICE_TYPE:"Gerätetyp",
    LISTENER:"Kleine Maschinen",
    BRIDGE:"Waschboxen",
    WASH_BOXES:"Waschboxen",
    VACUUMS:"Staubsauger",
    SAVE_NEWS:"Neuigkeit speichern",
    CREATE_NEW_NEWS:"Neue Neuigkeit erstellen",
    HISTORY_OF_ALL_NEWS:"Historie aller Neuigkeiten",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Geben Sie den Namen der Waschanlage ein",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Neue Waschanlage hinzufügen",
    NEWS_TEXT:"Text der Neuigkeit",
    NEWS_TITLE:"Titel der Neuigkeit",
    DELETE_NEWS_CONFIRMATION:"Möchten Sie die Neuigkeit löschen?",
    NEWS_DELETE_NOTIFICATION:"Sie haben erfolgreich die Neuigkeit gelöscht",
    NEWS_SAVE_NOTIFICATION:"Sie haben erfolgreich die Neuigkeit gespeichert",
    NEWS_CREATION_DATE:"Erstellungsdatum",
    NO_TITLE:"Ohne Titel",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Text der Neuigkeit darf nicht länger als 255 Zeichen sein",
    NEWS_TEXT_REQUIRED_VALIDATION:"Text der Neuigkeit ist erforderlich",
    NEWS_TITLE_REQUIRED_VALIDATION:"Titel der Neuigkeit ist erforderlich",
    DEACTIVATE:"Deaktivieren",
    ASIDE_MENU_LOCAL_TOKENS:"Lokale Wertmarken",
    CREATE_NEW_LOCAL_TOKENS:"Ausgabe neuer lokaler Wertmarken",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Geben Sie die E-Mail-Adresse des Kunden und die Anzahl der Wertmarken an, welche Sie ihm ausgeben möchten.",
    CREATE_TOKENS:"Wertmarken ausgeben",
    MINIMUM_ONE_TOKEN:"Der Wert muss größer als 0 sein",
    CUSTOMER_EMAIL:"Die E-Mail-Adresse des Kunden",
    AMOUNT_OF_TOKENS:"Anzahl der Wertmarken",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Erfolg bei der Ausgabe von Token an",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Ein Fehler ist  während der Ausgabe der Wertmarken aufgetreten. Bitte überprüfen Sie die E-Mail-Adresse des Kunden und versuchen Sie es erneut.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Übersicht aller ausgegebenen Wertmarken",
    ISSUED_AT:"ausgegeben am",
    ISSUED_BY:"ausgegeben von",
    CODE:"Gutscheincode",
    REDEEMED_BY:"eingelöst von",
    REDEEMED_AT:"eingelöst am",
    ASIDE_MENU_VOUCHERS:"Gutscheine",
    PRINT:"Drucken",
    VOUCHERS_OVERVIEW:"Übersicht der Gutscheine",
    CREATE_NEW_VOUCHERS:"Neue Gutscheine erstellen",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Erstellen Sie eine neue Gutscheinserie indem Sie die Anzahl der Wertmarken pro Gutschein bestimmen",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Anzahl der Wertmarken pro Gutschein",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Es ist erlaubt den Gutscheinen einen Wert zwischen 1 und 100 Wertmarken zuzuweisen",
    NUMBER_OF_NEW_VOUCHERS:"Anzahl an Gutscheinen in der Serie",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Sie können zwischen 1 und (Wert) Gutscheine in einer Serie erstellen",
    NEW_VOUCHERS_PREFIX:"Präfix der Gutscheinserie ",
    VALIDATION_VOUCHER_PREFIX:"Der Code-Präfix muss aus genau 4 Zeichen bestehen (Großbuchstaben und/oder Zahlen)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Es gab ein Problem während der Erstellung neuen Gutscheine. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
    CREATE_VOUCHERS:"Gutscheine erstellen",
    CREATING_VOUCHERS_SUCCESS:"Die neuen Gutscheine wurden erfolgreich erstellt",
    PRINT_NEW_VOUCHERS:"Gutscheine drucken",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Alternativ können Sie den Präfixcode für eine Gutscheinreihe eingeben, um die ganze Gutscheinreihe zu drucken",
    PRINT_VOUCHERS_PREFIX:"Präfixcode des Gutscheines (Serie)",
    NO_VOUCHERS_FOR_PRINT:"Es wurden keine Gutscheine mit dem angegebenen Präfixcode zum Drucken gefunden",
    PRINT_VOUCHERS:"Gutschein(e) drucken",
    VALIDATION_VOUCHER_CODE_FILTER:"Der Suchbegriff für den Gutschein muss aus Großbuchstaben und Zahlen bestehen",
    FILTER_VOUCHERS_BY_CODE:"Suche Gutscheine nach dem Einlösecode",
    FILTER_VOUCHERS:"Gutscheine finden",
    WASH_BOX:"Waschbox",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Insgesamt verwendete digitale Token",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Gesamtanzahl pro Tag verkaufter Wertmarken",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Gesamtanzahl ausgegebener Wertmarken nach Datum",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Gesamtanzahl ausgegebener Wertmarken nach Datum",
    LOCAL_TOKEN:"Lokale Wertmarke",
    GIVEN_TOKEN:"Lokal ausgegebene Wertmarken",
    SOLD_TOKEN:"Lokal verkaufte Wertmarken",
    SMALL_MACHINES:"kleine Anlagen",
    R2W_Listener:"Höhrer",
    HHANLE_DEVICE:"HHanle - Waschbox",
    CODE_PREFIX_EXIST:"Präfixcode existiert bereits",
    CODE_PREFIX_EXIST_TEXT:"Sie können keinen neuen Gutschein mit diesem Präfixcode erstellen. Bitte geben Sie einen anderen Code ein.",
    MIN_FOUR_VALIDATION:"Genau 4 Zeichen",
    ALL_INFORMATION_1:"Alle Informationen über",
    ALL_INFORMATION_2:"werden verloren sein",
    ASIDE_MENU_TRANSACTIONS:"Transaktionen",
    EXPENSES:"Ausgaben",
    TOPUPS:"Aufladungen",
    EXPENSES_LIST:"Liste der Ausgaben",
    USER_EMAIL:"Kunden E-mail",
    COMPANY_NAME:"Name der Firma",
    TOPUPS_LIST:"Liste der Aufladungen",
    CONSUMER:"Verbraucher",
    SYSTEM_ADMIN:"Systemadministrator",
    MERCHANT_ADMIN:"Betreiber",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Betreuer Waschanlage",
    SUBSCRIBER:"Abonnent",
    CONFIGURATOR:"Konfigurator",
    SETUP_UNIT_SERIAL_NO:"Seriennummer",
    SETUP_UNIT_MATERIAL_NO:"Materialnummer",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi - Version",
    TOTAL_TURNOVER:"Umsatz der Waschanlage",
    AVAILABILITY_ALL:"Verfügbarkeit",
    AVAILIBILITY:"Waschbox Verfügbarkeit:",
    AVAILABILITY_VACUUMS:"Staubsauger Verfügbarkeit:",
    WASH_BOX_INFO:"Info Waschboxen",
    VACUUM_CLEANER_INFO:"Info Staubsauger",
    BREAD_CRUMBS_SERVICE:"Service",
    HOLIDAYS:"Feiertage",
    HOLIDAY:"Feiertag",
    LIGHTS_ON:"Lichter an",
    LIGHTS_OFF:"Lichter aus",
    WASH_BOXES_ON:"Waschbox an",
    WASH_BOXES_OFF:"Waschbox aus",
    VACUUMS_ON:"Staubsauger an",
    VACUUMS_OFF:"Staubsauger aus",
    TURNOVER:"Umsatz",
    TURNOVER_MANUAL_WASH_UNIT:"Umsatz manuell",
    STATUS_BAY_RUN_TIME:"Gesamtstundenzähler Waschbox",
    STATUS_BAY_PROGRAM_NAME:"Programmname",
    STATUS_BAY_CREDIT:"Guthaben Waschbox",
    CLOUD_KREDIT:"Guthaben Cloud",
    STATUS_VACUUM_RUN_TIME:"Gesamtstundenzähler Staubsauger",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Informationen zu Diensten, Waschboxenprogrammen und aktuellen Fehlerdaten",
    UNAVAILABLE:"Einheit ist nicht verfügbar",
    SHOW_HIDE_TABLE:"Arbeitszeitentabelle anzeigen/verstecken",
    PROGRAM_NAME:"Programmname",
    PROGRAM_COUNTER:"Programmzähler",
    NO_NAME:"Die Referenz hat keinen Namen",
    COUNTER_SERVICE_DATA:"Sericedaten",
    NEED_SERVICE:"Service notwendig",
    PROGRAM_DATA:"Programmdaten der Waschbox",
    CURRENT_FAULT_DATA:"Aktuelle Fehlerdaten",
    REFERENCE_DUE:"wegen",
    REFERENCE_SECONDS:"Sekunden",
    REFERENCE_NAME:"Bauteilname",
    WASHBOX_NAME:"Name der Waschbox",
    FAULT_NAME:"Fehlerbezeichnung",
    FAULT_NUMBER:"Fehlernummer",
    CURRENT_FAULT_COUNT:"Aktive Fehler",
    DEVICE_NOT_INSTALLED:"Das Gerät ist nicht installiert",
    STATUS_READY:"Bereitschaftsstatus",
    STATUS_ERROR:"Fehlerstatus",
    CONNECTION_ERROR:"Verbindung getrennt",
    UNKNOWN_RESET:"Softwarefehler",
    SOFTWARE_RESET:"Softwarefehler",
    EXTERNAL_PIN_RESET:"Softwarefehler",
    RESTART_OR_BROWNOUT_OCCURRED:"Softwarefehler",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Hardwarefehler",
    COULD_NOT_SIMULATE_COIN:"Hardwarefehler",
    ERROR_SETTING_INHIBIT_MODE:"Hardwarefehler",
    OFFLINE_DEVICE:"Waschanlage vom Netz getrennt",
    TARIFFS:"Tarife",
    DAY:"Tag",
    NIGHT:"Nacht",
    VOUCHER_CODE:"Gutscheincode",
    DISMISS_ALARM:"Fehlermeldung zurücksetzen?",
    ALARM_ACTIVE:"Fehlermeldungen",
    NO_ALARM_ACTIVE:"Keine aktiven Fehlermeldungen",
    ALARM_HISTORY:"Fehlerhistorie",
    MANAGING_TOKENS:"Wertmarken verwalten",
    EXPIRATION_DATE:"Ablaufdatum",
    EXTEND_TOKEN_DATE:"Wertmarke ablaufdatum verlängern für",
    DELETE_TOKENS_FOR:"Wertmarken löschen für",
    PUMP_TYPE:"Pumpentyp",
    TURN_OFF_DEVICE:"Anlagenstatus",
    OPERATION_DATA:"Betriebsdaten",
    PUMP_DATA:"Pumpendaten",
    PUMP_NAME:"Pumpenname",
    POINT_NAME:"Bezugspunkt",
    CHANGER_INCOME:"Einnahmen vom Wechselautomaten nach Datum",
    SELECTED_OPEN:"Geöffnet zu ausgewählten Arbeitszeiten",
    ALWAYS_OPEN:"Immer geöffnet (24/7)",
    CLOSED:"Geschlossen",
    CLOSED_24:"24h geschlossen",
    OPENED_24:"24h geöffnet",
    MON:"Montag",
    TUE:"Dienstag",
    WED:"Mittwoch",
    THU:"Donnerstag",
    FRI:"Freitag",
    SAT:"Samstag",
    SUN:"Sonntag",
    PRICING:"Preise",
    PRICE:"Preis",
    SO_PRICE:"SO Preis",
    VALIDITY:"Geltungsbereich",
    TOKEN_PACKAGES:"Waschmünzen-Pakete",
    SINGLE_WASH:"Einzelwäsche",
    FACILITY_WORKING_HOURS:"Öffnungszeiten für die ausgewählte Anlage festlegen",
    WORKING_HOURS_ALWAYS_OPEN:"Immer geöffnet",
    WORKING_HOURS_ALWAYS_CLOSE:"Durch den Betreiber geschlossen",
    WORKING_HOURS_CUSTOM:"Öffnungszeiten festlegen",
    KARCHER_ERROR_CODE:"Fehlercode",
    KARCHER_ERROR_MESSAGE_1:"Ausgänge Elektronik überlastet",
    KARCHER_ERROR_MESSAGE_2:"Der Ölabscheider  muss geleert werden",
    KARCHER_ERROR_MESSAGE_4:"Dämmerungssensor defekt",
    KARCHER_ERROR_MESSAGE_5:"Motorschutzschalter Hochdruckpumpen hat ausgelöst",
    KARCHER_ERROR_MESSAGE_6:"Verbindung zum RDS gestört",
    KARCHER_ERROR_MESSAGE_7:"Druckschalter für Luft am Kompressor meldet keinen Druck",
    KARCHER_ERROR_MESSAGE_8:"Ursache: keine Verbindung zur Elektronik 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"Keine Verbindung zur Pumpenelektronik Waschplatz 1",
    KARCHER_ERROR_MESSAGE_11:"Ausgänge der Elektronik Waschplatz 1 überlastet",
    KARCHER_ERROR_MESSAGE_12:"Stromaufnahme Hochdruckpumpe Waschplatz 1 zu hoch",
    KARCHER_ERROR_MESSAGE_13:"Stromaufnahme Hochdruckpumpe Waschplatz 1 zu niedrig",
    KARCHER_ERROR_MESSAGE_14:"Schütz Hochdruckpumpe Waschplatz 1 klemmt",
    KARCHER_ERROR_MESSAGE_15:"Halblastventil Waschplatz 1 defekt",
    KARCHER_ERROR_MESSAGE_16:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 1 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_17:"Ölstand Hochdruckpumpe Waschplatz 1 zu niedrig",
    KARCHER_ERROR_MESSAGE_18:"Elektronik Waschplatz 1 defekt",
    KARCHER_ERROR_MESSAGE_19:"Motorschutzschalter Hochdruckpumpe Waschplatz 1 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_20:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 1",
    KARCHER_ERROR_MESSAGE_21:"Störung am Münzprüfer Waschplatz 1",
    KARCHER_ERROR_MESSAGE_22:"Störung am Münzprüfer Waschplatz 1",
    KARCHER_ERROR_MESSAGE_30:"Keine Verbindung zur Pumpenelektronik Waschplatz 2",
    KARCHER_ERROR_MESSAGE_31:"Ausgänge der Elektronik Waschplatz 2 überlastet",
    KARCHER_ERROR_MESSAGE_32:"Stromaufnahme Hochdruckpumpe Waschplatz 2 zu hoch",
    KARCHER_ERROR_MESSAGE_33:"Stromaufnahme Hochdruckpumpe Waschplatz 2 zu niedrig",
    KARCHER_ERROR_MESSAGE_34:"Schütz Hochdruckpumpe Waschplatz 2 klemmt",
    KARCHER_ERROR_MESSAGE_35:"Halblastventil Waschplatz 2 defekt",
    KARCHER_ERROR_MESSAGE_36:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 2 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_37:"Ölstand Hochdruckpumpe Waschplatz 2 zu niedrig",
    KARCHER_ERROR_MESSAGE_38:"Elektronik Waschplatz 2 defekt.",
    KARCHER_ERROR_MESSAGE_39:"Motorschutzschalter Hochdruckpumpe Waschplatz 2 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_40:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 2",
    KARCHER_ERROR_MESSAGE_41:"Störung am Münzprüfer Waschplatz 2",
    KARCHER_ERROR_MESSAGE_42:"Störung am Münzprüfer Waschplatz 2",
    KARCHER_ERROR_MESSAGE_50:"Keine Verbindung zur Pumpenelektronik Waschplatz 3",
    KARCHER_ERROR_MESSAGE_51:"Ausgänge der Elektronik Waschplatz 3 überlastet",
    KARCHER_ERROR_MESSAGE_52:"Stromaufnahme Hochdruckpumpe Waschplatz 3 zu hoch",
    KARCHER_ERROR_MESSAGE_53:"Stromaufnahme Hochdruckpumpe Waschplatz 3 zu niedrig",
    KARCHER_ERROR_MESSAGE_54:"Schütz Hochdruckpumpe Waschplatz 3 klemmt",
    KARCHER_ERROR_MESSAGE_55:"Halblastventil Waschplatz 3 defekt",
    KARCHER_ERROR_MESSAGE_56:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 3 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_57:"Ölstand Hochdruckpumpe Waschplatz 3 zu niedrig",
    KARCHER_ERROR_MESSAGE_58:"Elektronik Waschplatz 3 defekt.",
    KARCHER_ERROR_MESSAGE_59:"Motorschutzschalter Hochdruckpumpe Waschplatz 3 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_60:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 3",
    KARCHER_ERROR_MESSAGE_61:"Störung am Münzprüfer Waschplatz 3",
    KARCHER_ERROR_MESSAGE_62:"Störung am Münzprüfer Waschplatz 3",
    KARCHER_ERROR_MESSAGE_70:"Keine Verbindung zur Pumpenelektronik Waschplatz 4",
    KARCHER_ERROR_MESSAGE_71:"Ausgänge der Elektronik Waschplatz 4 überlastet",
    KARCHER_ERROR_MESSAGE_72:"Stromaufnahme Hochdruckpumpe Waschplatz 4 zu hoch",
    KARCHER_ERROR_MESSAGE_73:"Stromaufnahme Hochdruckpumpe Waschplatz 4 zu niedrig",
    KARCHER_ERROR_MESSAGE_74:"Schütz Hochdruckpumpe Waschplatz 4 klemmt",
    KARCHER_ERROR_MESSAGE_75:"Halblastventil Waschplatz 4 defekt",
    KARCHER_ERROR_MESSAGE_76:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 4 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_77:"Ölstand Hochdruckpumpe Waschplatz 4 zu niedrig",
    KARCHER_ERROR_MESSAGE_78:"Elektronik Waschplatz 4 defekt.",
    KARCHER_ERROR_MESSAGE_79:"Motorschutzschalter Hochdruckpumpe Waschplatz 4 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_80:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 4",
    KARCHER_ERROR_MESSAGE_81:"Störung am Münzprüfer Waschplatz 4",
    KARCHER_ERROR_MESSAGE_82:"Störung am Münzprüfer Waschplatz 4",
    KARCHER_ERROR_MESSAGE_90:"Keine Verbindung zur Pumpenelektronik Waschplatz 5",
    KARCHER_ERROR_MESSAGE_91:"Ausgänge der Elektronik Waschplatz 5 überlastet",
    KARCHER_ERROR_MESSAGE_92:"Stromaufnahme Hochdruckpumpe Waschplatz 5 zu hoch",
    KARCHER_ERROR_MESSAGE_93:"Stromaufnahme Hochdruckpumpe Waschplatz 5 zu niedrig",
    KARCHER_ERROR_MESSAGE_94:"Schütz Hochdruckpumpe Waschplatz 5 klemmt",
    KARCHER_ERROR_MESSAGE_95:"Halblastventil Waschplatz 5 defekt",
    KARCHER_ERROR_MESSAGE_96:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 5 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_97:"Ölstand Hochdruckpumpe Waschplatz 5 zu niedrig",
    KARCHER_ERROR_MESSAGE_98:"Elektronik Waschplatz 5 defekt.",
    KARCHER_ERROR_MESSAGE_99:"Motorschutzschalter Hochdruckpumpe Waschplatz 5 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_100:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 5",
    KARCHER_ERROR_MESSAGE_101:"Störung am Münzprüfer Waschplatz 5",
    KARCHER_ERROR_MESSAGE_102:"Störung am Münzprüfer Waschplatz 5",
    KARCHER_ERROR_MESSAGE_110:"Keine Verbindung zur Pumpenelektronik Waschplatz 6",
    KARCHER_ERROR_MESSAGE_111:"Ausgänge der Elektronik Waschplatz 6 überlastet",
    KARCHER_ERROR_MESSAGE_112:"Stromaufnahme Hochdruckpumpe Waschplatz 6 zu hoch",
    KARCHER_ERROR_MESSAGE_113:"Stromaufnahme Hochdruckpumpe Waschplatz 6 zu niedrig",
    KARCHER_ERROR_MESSAGE_114:"Schütz Hochdruckpumpe Waschplatz 6 klemmt",
    KARCHER_ERROR_MESSAGE_115:"Halblastventil Waschplatz 6 defekt",
    KARCHER_ERROR_MESSAGE_116:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 6 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_117:"Ölstand Hochdruckpumpe Waschplatz 6 zu niedrig",
    KARCHER_ERROR_MESSAGE_118:"Elektronik Waschplatz 6 defekt.",
    KARCHER_ERROR_MESSAGE_119:"Motorschutzschalter Hochdruckpumpe Waschplatz 6 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_120:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 6",
    KARCHER_ERROR_MESSAGE_121:"Störung am Münzprüfer Waschplatz 6",
    KARCHER_ERROR_MESSAGE_122:"Störung am Münzprüfer Waschplatz 6",
    KARCHER_ERROR_MESSAGE_130:"Keine Verbindung zur Pumpenelektronik Waschplatz 7",
    KARCHER_ERROR_MESSAGE_131:"Ausgänge der Elektronik Waschplatz 7 überlastet",
    KARCHER_ERROR_MESSAGE_132:"Stromaufnahme Hochdruckpumpe Waschplatz 7 zu hoch",
    KARCHER_ERROR_MESSAGE_133:"Stromaufnahme Hochdruckpumpe Waschplatz 7 zu niedrig",
    KARCHER_ERROR_MESSAGE_134:"Schütz Hochdruckpumpe Waschplatz 7 klemmt",
    KARCHER_ERROR_MESSAGE_135:"Halblastventil Waschplatz 7 defekt",
    KARCHER_ERROR_MESSAGE_136:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 7 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_137:"Ölstand Hochdruckpumpe Waschplatz 7 zu niedrig",
    KARCHER_ERROR_MESSAGE_138:"Elektronik Waschplatz 7 defekt.",
    KARCHER_ERROR_MESSAGE_139:"Motorschutzschalter Hochdruckpumpe Waschplatz 7 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_140:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 7",
    KARCHER_ERROR_MESSAGE_141:"Störung am Münzprüfer Waschplatz 7",
    KARCHER_ERROR_MESSAGE_142:"Störung am Münzprüfer Waschplatz 7",
    KARCHER_ERROR_MESSAGE_150:"Keine Verbindung zur Pumpenelektronik Waschplatz 8",
    KARCHER_ERROR_MESSAGE_151:"Ausgänge der Elektronik Waschplatz 8 überlastet",
    KARCHER_ERROR_MESSAGE_152:"Stromaufnahme Hochdruckpumpe Waschplatz 8 zu hoch",
    KARCHER_ERROR_MESSAGE_153:"Stromaufnahme Hochdruckpumpe Waschplatz 8 zu niedrig",
    KARCHER_ERROR_MESSAGE_154:"Schütz Hochdruckpumpe Waschplatz 8 klemmt",
    KARCHER_ERROR_MESSAGE_155:"Halblastventil Waschplatz 8 defekt",
    KARCHER_ERROR_MESSAGE_156:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 8 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_157:"Ölstand Hochdruckpumpe Waschplatz 8 zu niedrig",
    KARCHER_ERROR_MESSAGE_158:"Elektronik Waschplatz 8 defekt.",
    KARCHER_ERROR_MESSAGE_159:"Motorschutzschalter Hochdruckpumpe Waschplatz 8 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_160:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 8",
    KARCHER_ERROR_MESSAGE_161:"Störung am Münzprüfer Waschplatz 8",
    KARCHER_ERROR_MESSAGE_162:"Störung am Münzprüfer Waschplatz 8",
    KARCHER_ERROR_MESSAGE_170:"Keine Verbindung zur Elektronik A2",
    KARCHER_ERROR_MESSAGE_171:"Ausgänge der Elektronik A2 überlastet",
    KARCHER_ERROR_MESSAGE_172:"Reinigungsmittelbehälter leer",
    KARCHER_ERROR_MESSAGE_173:"Reinigungsmittelbehälter leer",
    KARCHER_ERROR_MESSAGE_174:"Reinigungsmittelbehälter leer",
    KARCHER_ERROR_MESSAGE_175:"Reinigungsmittelbehälter leer",
    KARCHER_ERROR_MESSAGE_176:"Reinigungsmittelbehälter leer",
    KARCHER_ERROR_MESSAGE_177:"Stromaufnahme Pumpe Unterbodenwäsche zu hoch",
    KARCHER_ERROR_MESSAGE_178:"Kein Druck nach Einschalten der Unterbodenwäsche",
    KARCHER_ERROR_MESSAGE_190:"Keine Verbindung zur Elektronik A3",
    KARCHER_ERROR_MESSAGE_191:"Ausgänge der Elektronik A3 überlastet",
    KARCHER_ERROR_MESSAGE_200:"Keine Verbindung zwischen Steuerung und Elektronik der WSO",
    KARCHER_ERROR_MESSAGE_201:"Ausgänge der Steuerung zur WSO überlastet",
    KARCHER_ERROR_MESSAGE_202:"Härtesensor zeigt nach Regeneration noch immer hartes Wasser an",
    KARCHER_ERROR_MESSAGE_204:"Störung in der Elektronik",
    KARCHER_ERROR_MESSAGE_210:"Wasserstandsensor 'Puffertank leer' aktiv",
    KARCHER_ERROR_MESSAGE_211:"Wasserstandsensor 'Puffertank leer' und 'Puffertank voll' gleichzeitig aktiv",
    KARCHER_ERROR_MESSAGE_212:"Wasserstandsensor 'Puffertank voll' aktiv. Keine Pumpe im Puffertank läuft.",
    KARCHER_ERROR_MESSAGE_213:"Kein Wasserdruck",
    KARCHER_ERROR_MESSAGE_214:"Bauseitige Wasseraufbereitungsanlage meldet Störung",
    KARCHER_ERROR_MESSAGE_220:"Wassermangel",
    KARCHER_ERROR_MESSAGE_221:"Abgastemperatur zu hoch",
    KARCHER_ERROR_MESSAGE_222:"Stromaufnahme Umwälzpumpe Warmwasser zu hoch",
    KARCHER_ERROR_MESSAGE_223:"Brennerstörung",
    KARCHER_ERROR_MESSAGE_224:"Sicherungsautomat Brenner hat ausgelöst",
    KARCHER_ERROR_MESSAGE_225:"Brennerverzögerung aktiv",
    KARCHER_ERROR_MESSAGE_226:"Der Durchflussanzeiger öffnete sich nicht innerhalb von 5 Sekunden, nachdem die Zirkulationspumpe für Warmwasser ausgeschaltet wurde",
    KARCHER_ERROR_MESSAGE_227:"Der Durchflussanzeiger schloss sich nicht innerhalb von 3 Sekunden, nachdem die Zirkulationspumpe für Warmwasser ausgeschaltet wurde",
    KARCHER_ERROR_MESSAGE_228:"Heißwasserausgang kühlt nach Abschaltung des Brenners zu langsam ab",
    KARCHER_ERROR_MESSAGE_229:"Störung Temperaursensor Warmwasser",
    KARCHER_ERROR_MESSAGE_230:"Störung Temperaursensor Brennerausgang",
    KARCHER_ERROR_MESSAGE_231:"Störung Temperaursensor Warmwasser",
    KARCHER_ERROR_MESSAGE_232:"Störung Temperaursensor Brennerausgang",
    KARCHER_ERROR_MESSAGE_233:"Wassertemperatur bei externer Versorgung mit Warmwasser über 60°C",
    KARCHER_ERROR_MESSAGE_234:"Fehler Antilegionellen-Programm",
    KARCHER_ERROR_MESSAGE_235:"Antilegionellen Warmwassertemperatur nicht erreicht",
    KARCHER_ERROR_MESSAGE_240:"Störung Außentemperatursensor",
    KARCHER_ERROR_MESSAGE_241:"Störung Außentemperatursensor",
    KARCHER_ERROR_MESSAGE_242:"Stromaufnahme Umwälzpumpe Frostschutz zu hoch",
    KARCHER_ERROR_MESSAGE_243:"Stromaufnahme Umwälzpumpe Waschplatzheizung zu hoch",
    KARCHER_ERROR_MESSAGE_244:"Warmwassertemperatur zu niedrig, Waschplatzheizung wurde abgestellt",
    KARCHER_ERROR_MESSAGE_245:"Stromaufnahme Schlauchheizung Trockenschaum zu hoch",
    KARCHER_ERROR_MESSAGE_247:"Störung in der Elektronik",
    KARCHER_ERROR_MESSAGE_248:"Störung in der Elektronik",
    KARCHER_ERROR_MESSAGE_250:"Stromaufnahme Pumpe für Sonder-Waschprogramm zu hoch",
    KARCHER_ERROR_MESSAGE_255:"Störung in der Elektronik",
    KARCHER_ERROR_MESSAGE_260:"Keine Verbindung zur Elektronik A5",
    KARCHER_ERROR_MESSAGE_261:"Ausgänge der Elektronik A5 überlastet",
    KARCHER_ERROR_MESSAGE_280:"Keine Verbindung zur Elektronik A6",
    KARCHER_ERROR_MESSAGE_281:"Ausgänge der Elektronik A6 überlastet",
    KARCHER_ERROR_MESSAGE_282:"Stromaufnahme Pumpe Felgenreiniger zu hoch",
    KARCHER_ERROR_MESSAGE_283:"Stromaufnahme Pumpe Felgenreiniger zu niedrig",
    KARCHER_ERROR_MESSAGE_284:"Schütz Pumpe Felgenreiniger klemmt",
    KARCHER_ERROR_MESSAGE_300:"Keine Verbindung zur Elektronik A7",
    KARCHER_ERROR_MESSAGE_301:"Ausgänge der Elektronik A7 überlastet",
    KARCHER_ERROR_MESSAGE_320:"Keine Verbindung zur Elektronik A8",
    KARCHER_ERROR_MESSAGE_321:"Ausgänge der Elektronik A8 überlastet",
    KARCHER_ERROR_MESSAGE_322:"Stromaufnahme Pumpe Microemulsion zu hoch",
    KARCHER_ERROR_MESSAGE_323:"Stromaufnahme Pumpe Microemulsion zu niedrig",
    KARCHER_ERROR_MESSAGE_324:"Schütz Pumpe Microemulsion klemmt",
    KARCHER_ERROR_MESSAGE_340:"Keine Verbindung zur Elektronik A9",
    KARCHER_ERROR_MESSAGE_341:"Ausgänge der Elektronik A9 überlastet",
    KARCHER_ERROR_MESSAGE_342:"Stromaufnahme Pumpe Intensivreinigung zu hoch",
    KARCHER_ERROR_MESSAGE_343:"Stromaufnahme Pumpe Intensivreinigung zu niedrig",
    KARCHER_ERROR_MESSAGE_344:"Schütz Pumpe Intensivreinigung klemmt",
    KARCHER_ERROR_MESSAGE_400:"Warmwasser hat keinen Druck",
    KARCHER_ERROR_MESSAGE_401:"Frischwasser hat keinen Druck",
    KARCHER_ERROR_MESSAGE_402:"Permeat hat keinen Druck",
    KARCHER_ERROR_MESSAGE_403:"4. Wasserart hat keinen Druck",
    KARCHER_ERROR_MESSAGE_404:"4. Wasserart, Temperatur über 60 °C oder externe Störung",
    KARCHER_ERROR_MESSAGE_405:"Frostschutz hat keinen Druck",
    KARCHER_ERROR_MESSAGE_406:"Druck im Frostschutz trotz ausgeschalteter Frostschutzpumpe",
    KARCHER_ERROR_MESSAGE_410:"Fehler F 400 ist 4 mal innerhalb 24 Stunden aufgetreten",
    KARCHER_ERROR_MESSAGE_411:"Fehler F 401 ist seit 300 Sekunden aktiv",
    KARCHER_ERROR_MESSAGE_412:"Fehler F 402 ist 4 mal innerhalb 24 Stunden aufgetreten",
    KARCHER_ERROR_MESSAGE_413:"Fehler F 403 ist 4 mal innerhalb 24 Stunden aufgetreten",
    KARCHER_ERROR_MESSAGE_414:"Fehler F 405 ist 4 mal innerhalb 24 Stunden aufgetreten",
    KARCHER_ERROR_MESSAGE_420:"Störung Wertmünzenwechsler 1",
    KARCHER_ERROR_MESSAGE_421:"Störung Wertmünzenwechsler 2",
    KARCHER_ERROR_MESSAGE_440:"Keine Verbindung zur Elektronik A31",
    KARCHER_ERROR_MESSAGE_441:"Ausgänge der Elektronik A31 überlastet",
    KARCHER_ERROR_MESSAGE_500:"Anschluss Staubsaugerelektronik 1/2",
    KARCHER_ERROR_MESSAGE_501:"Starttaster Sauger 1 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_502:"Starttaster Sauger 2 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_510:"Verbindung Elektronik Sauger 3/4",
    KARCHER_ERROR_MESSAGE_511:"Starttaster Sauger 3 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_512:"Starttaster Sauger 4 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_520:"Verbindung Elektronik Sauger 5/6",
    KARCHER_ERROR_MESSAGE_521:"Starttaster Sauger 5 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_522:"Starttaster Sauger 6 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_530:"Verbindung Elektronik Sauger 7/8",
    KARCHER_ERROR_MESSAGE_531:"Starttaster Sauger 7 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_532:"Starttaster Sauger 8 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_540:"Verbindung Elektronik Sauger 9/10",
    KARCHER_ERROR_MESSAGE_541:"Starttaster Sauger 9 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_542:"Starttaster Sauger 10 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_550:"Verbindung Elektronik Sauger 10/11",
    KARCHER_ERROR_MESSAGE_551:"Starttaster Sauger 11 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_552:"Starttaster Sauger 12 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_800:"Keine Verbindung zur Elektronik A30",
    KARCHER_ERROR_MESSAGE_801:"Ausgänge der Elektronik A30 überlastet",
    KARCHER_ERROR_MESSAGE_802:"Störung Enthärtungsanlage",
    KARCHER_ERROR_MESSAGE_803:"Motorschutzschalter Vordruckpumpe RO hat ausgelöst",
    KARCHER_INFO_MESSAGE_1:"Start Regeneration Basenaustauscher",
    KARCHER_INFO_MESSAGE_2:"Ende Regeneration Basenaustauscher",
    KARCHER_INFO_MESSAGE_3:"Basenaustauscher ist zu 75% erschöpft",
    KARCHER_INFO_MESSAGE_4:"Anlage aufgrund eines technischen Problems nicht verfügbar",
    KARCHER_INFO_MESSAGE_5:"Anlage aufgrund einer Betriebsstörung nicht verfügbar",
    KARCHER_INFO_MESSAGE_6:"Anlage wurde eingeschaltet",
    KARCHER_INFO_MESSAGE_10:"Anlage ausgeschaltet",
    KARCHER_INFO_MESSAGE_11:"Waschbox 1 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_12:"Waschbox 2 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_13:"Waschbox 3 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_14:"Waschbox 4 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_15:"Waschbox 5 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_16:"Waschbox 6 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_17:"Waschbox 7 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_18:"Waschbox 8 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_20:"Antilegionellen Programm Warmwassertank",
    KARCHER_INFO_MESSAGE_21:"Antilegionellen Programm HD Pumpe 1 erforderlich",
    KARCHER_INFO_MESSAGE_22:"Antilegionellen Programm HD Pumpe 2 erforderlich",
    KARCHER_INFO_MESSAGE_23:"Antilegionellen Programm HD Pumpe 3 erforderlich",
    KARCHER_INFO_MESSAGE_24:"Antilegionellen Programm HD Pumpe 4 erforderlich",
    KARCHER_INFO_MESSAGE_25:"Antilegionellen Programm HD Pumpe 5 erforderlich",
    KARCHER_INFO_MESSAGE_26:"Antilegionellen Programm HD Pumpe 6 erforderlich",
    KARCHER_INFO_MESSAGE_27:"Antilegionellen Programm HD Pumpe 7 erforderlich",
    KARCHER_INFO_MESSAGE_28:"Antilegionellen Programm HD Pumpe 8 erforderlich",
    KARCHER_INFO_MESSAGE_29:"Antilegionellen Programm erfolgreich durchgeführt",
    KARCHER_INFO_MESSAGE_101:"HD Pumpe Waschplatz 1: Wartung fällig",
    KARCHER_INFO_MESSAGE_102:"HD Pumpe Waschplatz 2: Wartung fällig",
    KARCHER_INFO_MESSAGE_103:"HD Pumpe Waschplatz 3: Wartung fällig",
    KARCHER_INFO_MESSAGE_104:"HD Pumpe Waschplatz 4: Wartung fällig",
    KARCHER_INFO_MESSAGE_105:"HD Pumpe Waschplatz 5: Wartung fällig",
    KARCHER_INFO_MESSAGE_106:"HD Pumpe Waschplatz 6: Wartung fällig",
    KARCHER_INFO_MESSAGE_107:"HD Pumpe Waschplatz 7: Wartung fällig",
    KARCHER_INFO_MESSAGE_108:"HD Pumpe Waschplatz 8: Wartung fällig",
    KARCHER_INFO_MESSAGE_109:"Brenner: Wartung fällig",
    KARCHER_INFO_MESSAGE_110:"Brennergebläse: Wartung fällig",
    KARCHER_INFO_MESSAGE_111:"Warmwasserpumpe: Wartung fällig",
    KARCHER_INFO_MESSAGE_112:"Frostschutzpumpe: Wartung fällig",
    KARCHER_INFO_MESSAGE_113:"Vordruckpumpe Osmose: Wartung fällig",
    KARCHER_INFO_MESSAGE_114:"Pumpe Fußbodenheizung: Wartung fällig",
    KARCHER_INFO_MESSAGE_115:"Schlauchheizung: Wartung fällig",
    KARCHER_INFO_MESSAGE_116:"Pumpe Mikroemulsion / Felgenreiniger: Wartung fällig",
    KARCHER_INFO_MESSAGE_117:"Pumpe Unterbodenwäsche: Wartung fällig",
    KARCHER_INFO_MESSAGE_118:"Vordruckpumpe Schaum: Wartung fällig",
    KARCHER_INFO_MESSAGE_119:"Sauger 1: Wartung fällig",
    KARCHER_INFO_MESSAGE_120:"Sauger 2: Wartung fällig",
    KARCHER_INFO_MESSAGE_121:"Sauger 3: Wartung fällig",
    KARCHER_INFO_MESSAGE_122:"Sauger 4: Wartung fällig",
    KARCHER_INFO_MESSAGE_123:"Sauger 5: Wartung fällig",
    KARCHER_INFO_MESSAGE_124:"Sauger 6: Wartung fällig",
    KARCHER_INFO_MESSAGE_125:"Sauger 7: Wartung fällig",
    KARCHER_INFO_MESSAGE_126:"Sauger 8: Wartung fällig",
    KARCHER_INFO_MESSAGE_127:"Sauger 9: Wartung fällig",
    KARCHER_INFO_MESSAGE_128:"Sauger 10: Wartung fällig",
    KARCHER_INFO_MESSAGE_129:"Sauger 11: Wartung fällig",
    KARCHER_INFO_MESSAGE_130:"Sauger 12: Wartung fällig",
    KARCHER_INFO_MESSAGE_131:"Pumpe Felgenreiniger: Wartung fällig",
    KARCHER_INFO_MESSAGE_132:"Pumpe Mikroemulsion: Wartung fällig",
    KARCHER_INFO_MESSAGE_133:"Pumpe Intensivschaum: Wartung fällig",
    KARCHER_INFO_MESSAGE_142:"Sauger 1 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_143:"Sauger 1 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_144:"Sauger 2 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_145:"Sauger 2 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_146:"Sauger 3 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_147:"Sauger 3 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_148:"Sauger 4 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_149:"Sauger 4 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_150:"Sauger 5 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_151:"Sauger 5 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_152:"Sauger 6 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_153:"Sauger 6 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_154:"Sauger 7 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_155:"Sauger 7 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_156:"Sauger 8 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_157:"Sauger 8 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_158:"Sauger 9 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_159:"Sauger 9 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_160:"Sauger 10 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_161:"Sauger 10 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_162:"Sauger 11 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_163:"Sauger 11 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_164:"Sauger 12 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_165:"Sauger 12 Filter: Wartung fällig",
    ORGANIZATION:"Organisation",
    CREATE_ORGANIZATION:"Organisation erstellen",
    CREATE_ORGANIZATION_AS:"Unterorganisation erstellen",
    DELETE_ORGANIZATION:"Organisation löschen",
    EDIT_ORGANIZATION:"Organisation bearbeiten",
    SUPPORTED_ORG_NAME:"Unterstützte Organisation",
    SUPPORTED_ORG_TYPE:"Kooperationstyp",
    ORG_NAME:"Name",
    ORG_TYPE:"Typ",
    SET_ORG_TITLE:"Unterorganisation festlegen",
    SET_SUPPORTED_ORG_TITLE:"Unterstützte Unterorganisation festlegen",
    SAVE_ORGANIZATION:"Organisation sichern",
    SELECT_ORGANIZATION_TYPE:"Wähle Organisationstyp",
    SELECT_ORGANIZATION_SELECTOR:"Wählen",
    SELECT_SUPPORTED_ORGANIZATION:"Wählen Sie aus den verfügbaren Organisationen/ Standorten ihren Kooperationspartner",
    ORGANIZATION_DELETED:"Organisation erfolgreich gelöscht ",
    ORGANIZATION_SAVED:"Organisation erfolgreich gespeichert",
    ORGANIZATION_UPDATED:"Organisation erfolgreich aktualisiert",
    ALERTS:"Fehlermeldungen",
    DEVICE_STATUS:"Gerätestatus",
    SITE_DETAILS:"Einzelheiten zum Standort",
    ALARM_STATUS:"Alarmstatus",
    FILTER:"Filtern nach...",
    FILTER_BY_ALERT_CENTER:"Filtern nach Stichwort, Name oder Beschreibung",
    TOTAL_ALARM:"Gesamt",
    LOW_ALARM:"Ereignis",
    MEDIUM_ALARM:"Warnungen",
    HIGH_ALARM:"Kritische Fehler",
    NO_FACILITIES_NEARBY:"Es sind keine Waschanlagen in der Nähe",
    GRAY_MAP:"Karte in Grau",
    READY:"Bereit",
    WARNING:"Warnungen",
    ERROR:"Fehler",
    SITE_NAME:"Standortname",
    ACCOUNTS_INFO:"Profilinformationen",
    USER_ORGANIZATION:"Kundenorganisation",
    ADD_USER_ORGANIZATION:"Einen neuen Benutzer für die Organisation hinzufügen",
    EDIT_USER_ORGANIZATION:"Die Benutzer der Organisation bearbeiten",
    SELECT_ROLE:"Rolle wählen",
    SELECT_ORGANIZATION:"Organisation wählen",
    SELECT_USER:"Benutzer wählen",
    USER_FOR_ORGANIZATION_CREATED:"Der neue Benutzer wurde erfolgreich erstellt",
    SELECT_REGION:"Region wählen",
    SELECT_LANGUAGE:"Sprache wählen",
    LOADING_DATA:"Die Daten werden geladen, bitte warten Sie einen Moment...",
    ADMINISTRATOR:"Administrator",
    TECHNICAL_SUPPORT:"Technischer Support",
    CONTROLLER:"Steuergerät",
    EDIT_ORGANIZATION_USER:"Benutzer der Organisation bearbeiten",
    DELETE_ORGANIZATION_USER:"Benutzer der Organisation löschen",
    USER_UPDATED:"Benutzer erfolgreich aktualisiert",
    USER_CREATED:"Benutzer erfolgreich erstellt",
    ADDRESS:"Adresse",
    SUBSCRIPTIONS:"Abonnements",
    RESOLVED_STATUS:"behoben",
    NOT_RESOLVED_STATUS:"Nicht behoben",
    ALERT_NAME:"Fehlermeldung",
    ALERT_DESCRIPTION:"Fehlerbeschreibung",
    ALERT_CODE:"Fehlercode",
    ALERT_TYPE:"Fehlertyp",
    UNSUBSCRIBE:"Abonnement löschen",
    SUBSCRIBE:"Fehlermeldung abonnieren",
    ALARM_SUBSCRIBED:"Abonnement erfolgreich abgeschlossen",
    UNSUBSCRIBED_CONFIRM:"Abonnement beenden?",
    ALARM_UNSUBSCRIBED:"Abonnement erfolgreich beendet",
    ASIDE_MENU_CASHLESS_SALES:"Bargeldlose Zahlungen",
    FILTERED_CASHLESS_PAYMENTS:"Gefiltert nach bargeldlosen Zahlungen",
    REFUND_DIALOG_TITLE:"Transaktion zurückerstatten?",
    REFUND_DIALOG_SUBTITLE:"Die Rückerstattung kann kleiner oder gleichgroß wie die ursprüngliche Transaktion sein",
    REFUND:"Erstattung",
    INPUT_NOT_VALID:"Die Eingabe ist ungültig",
    REFUND_SUCCESSFULLY:"Die Rückerstattung der ausgewählten Transaktion war erfolgreich",
    USER:"Benutzer",
    TRANSACTION_ID:"PSP-Referenz",
    DEVICE_ID:"Geräte ID",
    NET_AMOUNT:"Netto- Betrag",
    REPORT_NAME:"Name melden",
    TIME_FRAME:"Zeitfenster",
    SUB_POINT:"Waschplatz wählen",
    SUB_POINT_LIST_NOT_EXIST:"Es existieren keine Unterpunkte bei der gewählten Waschanlage",
    FACILITY_TYPE:"Waschanlagentyp",
    MACHINE_NAME:"Name Waschanlage",
    WASH_FACILITY_DETAILS:"Waschanlagendetails",
    WASH_BAY_DETAILS:"Details zur Waschbox",
    DEVICES_INFO:"Waschplätze",
    OPERATION_TIME_INFO:"Öffnungszeiten Waschplätze",
    OPERATION_TIME_VACUUM_INFO:"Öffnungszeiten Staubsauger",
    OPERATION_TIME_ILLUMINATION_INFO:"Betriebszeiten Beleuchtung",
    AVAILABLE_TITLE:"Verfügbar",
    UNAVAILABLE_TITLE:"Nicht Verfügbar",
    CURRENT_PROGRAM:"Aktuelles Programm",
    CREDITS:"Guthaben",
    DEVICE_NAME:"Gerätename",
    ACTIVE_ALARMS:"Fehlermeldungen",
    ALL_DAY:"Ganztags",
    OPERATING_TIME_WASH_FACILITY:"SB-Anlage Waschsystem",
    OPERATING_TIME_VACUUMS:"Staubsauger",
    OPERATING_TIME_ILLUMINATION:"Beleuchtung",
    OPERATION_COUNTERS:"Betriebsstunden- und Wartungszähler",
    EDIT:"Bearbeiten",
    WASHING_PROGRAMS:"Waschprogramme",
    INFO:"Ereignis",
    STATISTIC:"Statistik",
    ROLLOVER_DOSING:"Dosierung",
    ROLLOVER_SPEED:"Geschwindigkeiten",
    ROLLOVER_RESETS:"Portalanlage zurücksetzen via Fernbedienung",
    ROLLOVER_RESETS_INFO:"Achtung, das Zurücksetzen der Portalanlage muss den örtlichen Regularien entsprechen.WICHTIG: VOR DEM ZURÜCKSETZEN IST ES DIE VERANTWORTUNG DES KUNDEN, SICHERZUSTELLEN, DASS DIE WASCHHALLE FREI VON FAHRZEUGEN UND MENSCHEN IST.",
    RESET_ROLLOVER:"Portalanlage zurücksetzten",
    OPEN_DOOR_ROLLOVER:"Öffnen",
    ROLLOVER_OPEN_DOOR_INFO:"Das Rolltor wird geöffnet. Vorsicht bitte.",
    ROLLOVER_OPEN_DOOR:"Rolltor öffnen",
    APPLY_DOSING_CHANGES:"Änderung an den Dosiereinstellungen übernehmen",
    APPLY_SPEED_CHANGES:"Änderungen an der Verfahrgeschwindigkeit übernehmen",
    ACTUATION_SUCCESS:"Anfrage gesendet",
    REMAINING_TIME:"Verbleibende Zeit",
    OPEN_24H:"24 Stunden geöffnet",
    CLOSE_24H:"24 Stunden geschlossen",
    VALIDATION_OPERATION_TIME:"Format nicht korrekt. Bitte verwenden Sie das Format 'hh:mm' Uhr",
    ROLLOVER:"Portalanlage",
    UPDATE_WASHING_PROGRAM:"Waschprogramm aktualisieren",
    UPDATE_ACTUATORS:"Akteure aktualisieren",
    OPEN_ROLOVER_DOOR_TITLE:"Möchten Sie das Rolltor öffnen?",
    OPEN_ROLOVER_DOOR_CONTENT:"Wollen Sie das Rolltor wirklich öffnen?",
    RESET_ROLOVER_TITLE:"Wollen Sie den Waschvorgang zurücksetzen?",
    RESET_ROLOVER_CONTENT:"Wollen Sie den Waschvorgang wirklich zurücksetzen?",
    G0:"{{brand === 'r2w' ? 'Waschplatz 0' : 'Waschplatz 1'}}",
    G1:"{{brand === 'r2w' ? 'Waschplatz 1' : 'Waschplatz 2'}}",
    G2:"{{brand === 'r2w' ? 'Waschplatz 2' : 'Waschplatz 3'}}",
    G3:"{{brand === 'r2w' ? 'Waschplatz 3' : 'Waschplatz 4'}}",
    G4:"{{brand === 'r2w' ? 'Waschplatz 4' : 'Waschplatz 5'}}",
    G5:"{{brand === 'r2w' ? 'Waschplatz 5' : 'Waschplatz 6'}}",
    G6:"{{brand === 'r2w' ? 'Waschplatz 6' : 'Waschplatz 7'}}",
    G7:"{{brand === 'r2w' ? 'Waschplatz 7' : 'Waschplatz 8'}}",
    G8:"{{brand === 'r2w' ? 'Waschplatz 8' : 'Waschplatz 9'}}",
    G9:"{{brand === 'r2w' ? 'Waschplatz 9' : 'Waschplatz 10'}}",
    G10:"{{brand === 'r2w' ? 'Waschplatz 10' : 'Waschplatz 11'}}",
    U0:"{{brand === 'r2w' ? 'Staubsauger 0' : 'Staubsauger 1'}}",
    U1:"{{brand === 'r2w' ? 'Staubsauger 1' : 'Staubsauger 2'}}",
    U2:"{{brand === 'r2w' ? 'Staubsauger 2' : 'Staubsauger 3'}}",
    U3:"{{brand === 'r2w' ? 'Staubsauger 3' : 'Staubsauger 4'}}",
    U4:"{{brand === 'r2w' ? 'Staubsauger 4' : 'Staubsauger 5'}}",
    U5:"{{brand === 'r2w' ? 'Staubsauger 5' : 'Staubsauger 6'}}",
    U6:"{{brand === 'r2w' ? 'Staubsauger 6' : 'Staubsauger 7'}}",
    U7:"{{brand === 'r2w' ? 'Staubsauger 7' : 'Staubsauger 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Bericht des Fehlerspeicher zu der ausgewählten Seite des Dashboards.",
    ALERT_CENTER_TITLE_BY_FACILITY:"Bericht des Fehlerspeicher zu der ausgewählten Anlage des Dashboards.",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Fehlerspeicher",
    ERROR_MESSAGE_403:"Sie haben keine Berechtigung, diesen API-Aufruf zu verwenden. Fehlercode: 403",
    LAST_ACTIVE_PROGRAM:"Aktuelles- oder zuletzt aktives Programm",
    PROGRAM_ID:"Programmnummer",
    PROGRAM_PRICE:"Preis",
    PROGRAM_SO_PRICE:"SO Preis",
    PROGRAM_DESCRIPTION: "Programmbeschreibung",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Nachfüllen erforderlich",
    EMPTY_CHEMICAL_LEVEL:"Leer",
    CHEMICAL_LEVEL:"Füllstand Reinigungsmittel (%)",
    ROLLOVER_STATUS:"Anlagenstatus",
    ROLLOVER_STATUS_CODE_0:"Waschanlage außer Betrieb",
    ROLLOVER_STATUS_CODE_1:"Außerhalb der Öffnungszeiten",
    ROLLOVER_STATUS_CODE_2:"Anlage frei",
    ROLLOVER_STATUS_CODE_3:"Bitte positionieren Sie ihr Fahrzeug",
    ROLLOVER_STATUS_CODE_4:"Bitte fahren Sie etwas weiter vor",
    ROLLOVER_STATUS_CODE_5:"Bitte fahren Sie etwas zurück",
    ROLLOVER_STATUS_CODE_6:"Fahrzeug korrekt positioniert",
    ROLLOVER_STATUS_CODE_7:"Waschvorgang aktiv",
    ROLLOVER_STATUS_CODE_8:"Der Waschvorgang wurde gestoppt",
    ROLLOVER_STATUS_CODE_9:"Waschvorgang aktiv (Takt)",
    ROLLOVER_STATUS_CODE_10:"Bitte fahren Sie mit ihrem Fahrzeug rückwärts aus der Waschanlage.",
    ROLLOVER_STATUS_CODE_11:"Not-Stop",
    ROLLOVER_STATUS_CODE_12:"Bitte fahren Sie mit ihrem Fahrzeug vorwärts aus der Waschanlage.",
    ROLLOVER_STATUS_CODE_13:"Frostschutz aktiv",
    ROLLOVER_STATUS_CODE_14:"Sicherheitsschalter Vorderseite ausgelöst!",
    ROLLOVER_STATUS_CODE_15:"Sicherheitsschalter Rückseite ausgelöst!",
    ROLLOVER_STATUS_CODE_16:"Sicherheitsschalter vorne links hat ausgelöst!",
    ROLLOVER_STATUS_CODE_17:"Sicherheitsschalter vorne rechts hat ausgelöst!",
    ROLLOVER_STATUS_CODE_18:"Sicherheitsschalter hinten links hat ausgelöst!",
    ROLLOVER_STATUS_CODE_19:"Sicherheitsschalter hinten rechts hat ausgelöst!",
    ROLLOVER_STATUS_CODE_20:"Ihr Fahrzeug steht zu weit links",
    ROLLOVER_STATUS_CODE_21:"Ihr Fahrzeug steht zu weit rechts",
    ROLLOVER_STATUS_CODE_22:"Die linke Fahrzeugtür ist nicht geschlossen",
    ROLLOVER_STATUS_CODE_23:"Die rechte Fahrzeugtür ist nicht geschlossen",
    ROLLOVER_STATUS_CODE_24:"Transporter erkannt, falsches Waschprogramm gewählt!",
    ROLLOVER_STATUS_CODE_25:"Sensor akustisches Signal",
    ROLLOVER_STATUS_CODE_98:"Modus manuelle Einstellungen",
    ROLLOVER_STATUS_CODE_99:"Unbekannter Zustand",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status Code unbekannt",
    ALARM:"Kritischer Fehler",
    NO_ALARM:"Unkritischer Fehler",
    SOFTWARE_VERSION:"Software Version",
    SOFTWARE_DATE:"Erscheinungsdatum Software",
    SITE_ADDRESS:"Standortadresse",
    SECONDS:"Sekunden",
    SERVICE_PART_NAME:"Wartungsname:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Betriebs- und Wartungszähler",
    OPERATION_COUNTER:"Betriebszähler",
    SERVICE_COUNTER:"Wartungszähler",
    FAULT_CODE:"Fehlercode",
    PRESSURE_TITLE:"Luftdruck",
    TIME_TITLE:"Aktuelle Uhrzeit",
    COUNTRY_TITLE:"Land",
    CITY_TITLE:"Stadt",
    REGION_TITLE:"Region",
    SELECT_POINTS_TO_SEARCH:"Wähle Suchkriterien...",
    LOGS_HISTORY:"Änderungshistorie",
    ACTUATOR_REFERENCE:"Referenz",
    ACTUATOR_VALUE:"Wert",
    POINT_ID:"Punkt-ID",
    VALIDATION_NOT_VALID_RANGE:"Wert außerhalb des zugelassenen Bereichs",
    ENABLE_ROLLOVER_RESET:"Wenn Sie in diese Box einen Haken setzen bestätigen Sie, dass Sie die Sicherheitshinweise gelesen und akzeptiert haben.",
    CHANGE_OF_PARAMETERS:"Parameter ändern",
    SELECT_OPTIONS:"Optionen wählen",
    AUTOMATIC:"Automatik",
    DESALTING:"Entsalzungsfunktion",
    SEASON_WASH:"Saisonale Waschprogramme",
    SPRING_PROGRAM:"Waschprogramme Frühling",
    SUMMER_PROGRAM:"Waschprogramme Sommer",
    AUTUMN_PROGRAM:"Waschprogramme Herbst",
    WINTER_PROGRAM:"Waschprogramme Winter",
    DOOR_CONTROL:"Steuerung Rolltor",
    SUMMER_DOOR_CONTROL:"Sommersaison: Betrieb mit der Torsteuerung im Sommermodus",
    WINTER_DOOR_CONTROL:"Wintersaison: Betrieb mit der Torsteuerung im Wintermodus",
    APPLY_PARAMETERS_CHANGES:"Änderungen bestätigen",
    WORKING_SCHEDULES:"Öffnungszeiten",
    HOLIDAY_SCHEDULES:"Feiertagspläne",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Feiertage vor Ort erfolgreich erstellt",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Feiertage vor Ort erfolgreich aktualisiert",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Feiertage vor Ort erfolgreich gelöscht",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Arbeitszeiten erfolgreich ausgerufen",
    HOLIDAY_SUCCESSFULLY_DELETED:"Feiertag(e) erfolgreich gelöscht",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:" CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Trocknungsmittel mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_SHAMPOO:"Flüssigwaschmittel mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_FOAM:"Schaum mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_WAX_1:"Wachs mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_POLISH_1:"Polish mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Felgenreiniger mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_WAX_2:"Wachs mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Reifenglanz mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Insektenreiniger mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_POLISH_2:"Polish mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_INTENSIVE:"Intensivreiniger mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Niedriger Füllstand: Schaumregen",
    CHEM_LEVEL_DRYING_AGENT:"Füllstand Trocknungsmittel",
    CHEM_LEVEL_SHAMPOO:"Füllstand Flüssigseife",
    CHEM_LEVEL_FOAM:"Füllstand Schaum",
    CHEM_LEVEL_WAX_1:"Füllstand Wachs",
    CHEM_LEVEL_POLISH_1:"Füllstand Polish",
    CHEM_LEVEL_RIM_CLEANER:"Füllstand Felgenreiniger",
    CHEM_LEVEL_WAX_2:"Füllstand Wachs",
    CHEM_LEVEL_TYRE_SHINE:"Füllstand Reifenglanz",
    CHEM_LEVEL_INSECT_REMOVER:"Füllstand Insektenentferner",
    CHEM_LEVEL_POLISH_2:"Füllstand Polish",
    CHEM_LEVEL_INTENSIVE:"Füllstand Intensivreiniger",
    CHEM_LEVEL_FOAM_RAIN:"Füllstand Schaumregen",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Servicezähler Dachbürste-Hebeband",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Servicezähler Trockner-Hebeband",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Servicezähler Dachbürste Motorkabel",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Servicezähler Frischwasserpumpe",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Servicezähler Bracuhwasserpumpe",
    DRYING_AGENT:"Trocknungsmittel",
    FOAM_DRYING_AGENT:"Schaumtrocknungsmittel",
    SHAMPOO:"Flüssigwaschmittel",
    FOAM:"Schaum",
    BRUSH_FOAM:"Bürstenschaum",
    WAX_1:"Wachs",
    FOAM_WAX_1:"Schaumwachs 1",
    POLISH_1:"Polish 1",
    RIM_CLEANING:"Felgenreiniger",
    WAX_2:"Wachs",
    FOAM_WAX_2:"Schaumwachs 2",
    TYRE_SHINE:"Reifenglanz",
    INSECT_REMOVER:"Insektenreiniger",
    POLISH_2:"Polish 2",
    INTENSIVE_BASIC:"Intensiv Basic",
    INTENSIVE_SIDE:"Intensiv Seite",
    INTENSIVE_ROOF_SPRAY_BAR:"Intensiv Dachsprühbogen",
    TAR_REMOVER:"Teerentferner",
    UNDER_CHASSIS_CONVERSATION:"Unterbodenversiegelung",
    STATIONARY_PRE_SPRAY_ARCH:"Stationärer Vorsprühbogen",
    FOAM_RAIN:"Schaumregen",
    PRE_CLEANING:"Vorwäsche",
    BRUSH:"Bürsten",
    CARE:"Pflege",
    DRYING:"Trocknung",
    DRYING_LOW_NOISE:"Lärmreduzierte Trocknung",
    INTENSIVE_CLEANING:"Intensivwäsche",
    BRUSH_CLEANING:"Bürstenwäsche",
    EMPTY_RUN:"Leerfahrt",
    DRYING_AID:"Trocknungshilfe",
    WAX:"Wachs",
    FOAM_WASH:"Schaumwäsche",
    POLISH:"Polish",
    FOAM_POLISH:"Schaumpolish",
    WHEEL_CLEANING:"Felgen vorsprühen",
    HIGH_PRESSURE_ROOF:"Hochdruck Dach",
    HIGH_PRESSURE_SIDE:"Seitenhochdruck",
    DRYER_FORWARD:"Trocknung vorwärts",
    DRYER_BACKWARD:"Trocknung rückwärts",
    DELETE_ALL_HOLIDAYS:"Alle Urlaube für ausgewählte Anlage löschen",
    CREATE_NEW_HOLIDAY:"Neu erstellen",
    RESET_INPUTS:"Alle Urlaube zurücksetzen",
    TWENTY_FOUR_HOURS_OPEN:"24 Stunden geöffnet",
    EVERY_YEAR:"Jährlich",
    DELETE_HOLIDAY:"Urlaub löschen",
    ADD_NEW_HOLIDAY:"Neuen Urlaub hinzufügen",
    HOLIDAYS_LIST:"Liste der bestehenden Urlaube",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Alle Urlaube für ausgewählte Anlage löschen?",
    VALIDATION_HOLIDAY_DATE:"Format nicht korrekt. Bitte MM-DD benutzen",
    FOR_DATE:"Für Datum",
    WITH_ID:"Mit ID",
    FROM_HOURS:"Von (h)",
    FROM_MINUTES:"Von (min)",
    TO_HOURS:"bis (h)",
    TO_MINUTES:"Bis (min)",
    NOT_MATCH:"Passt nicht",
    START:"Von",
    STOP:"Bis",
    DAILY_TIME:"24 Stunden Liste",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individuelle Zeiteinstellung",
    PROGRAM_NOT_STARTED:"Programm noch nicht gestartet",
    JETWASH:"SB-Anlage Waschsystem",
    KARCHER_REPORT_1:"Portalwäsche: Umsatzindikation pro Programm und insgesamt",
    KARCHER_REPORT_2:"Portalwäsche: Gestartete Wäschen pro Programm und insgesamt",
    KARCHER_REPORT_3:"Portalwäsche: Durchgeführte Waschvorgänge pro Programm und insgesamt",
    KARCHER_REPORT_4:"Portalwäsche: Anzahl der gestarteten Wäschen über das Bezahlungsterminal pro Programm und insgesamt",
    KARCHER_REPORT_5:"Portalwäsche: Anzahl der manuell gestarteten Wäschen pro Programm und insgesamt",
    KARCHER_REPORT_6:"Portalwäsche: Anzahl der abgebrochenen Wäschen pro Programm und insgesamt",
    KARCHER_REPORT_7:"Portalanlage: Anzahl der Stromausfälle",
    KARCHER_REPORT_8:"SB-Anlage: Betriebsstunden pro Waschprogramm gefiltert nach Waschplatz und gesamt",
    KARCHER_REPORT_9:"SB-Anlage: Umsatzindikation pro Waschplatz und gesamt",
    KARCHER_REPORT_10:"SB-Anlage: Wertmarken-/Münzenzähler pro Münzkanal",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Frischwasserpumpe",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Prozesswasserpumpe",
    OPERATION_COUNTER_HP_PUMP_1:"Hochdruckpumpe 1",
    OPERATION_COUNTER_HP_PUMP_2:"Hochdruckpumpe 2",
    RELEASE_NOTES:"App-Versionen und Versionshinweise",
    BACKEND_RELEASE_NOTES:"Versionshinweise zur Plattform:",
    FRONTEND_RELEASE_NOTES:"Webanwendung Versionshinweise:",
    SELECTED_FACILITY_TIMEZONE:"Zeitzone für ausgewählte Anlage:",
    REFRESH_PAGE:"Seite neu laden",
    REFRESH_MAPS:"Karte neu laden",
    PUMPS:"Pumpen",
    RUN_TIME:"Laufzeit",
    RUN_TIME1:"Laufzeit 1",
    RUN_TIME2:"Laufzeit 2",
    PROGRAM_RUNTIME_ACTUATOR:"Aktuator für Laufzeit",
    PROGRAM_RUNTIME_ACTUATOR_1:"Aktuator für Laufzeit 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Aktuator für Laufzeit 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Min-Wert ist 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Max-Wert ist 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Preis im Format x.xx verwenden",
    ACTUATION_NOT_ALLOWED:"Betätigung für aktuelle Benutzerrolle nicht zulässig",
    MAINTENANCE_DAYS:"Wartungstage",
    MAINTENANCE_WASHES:"Wartungswäschen",
    DAILY_FINANCES_POS:"Kartenterminal",
    POS_INCOME:"Gesamteinkommen Kartenterminal",
    PROPAGATE:"Verbreiten",
    ALL_DAY_HOURS_SELECTOR:"24 Stunden Einstellung",
    GET_OPERATING_TIME_FROM_SITE:"Betriebszeit des aktuellen Geräts aus den Einsatzplänen der Anlage abrufen",
    USER_NOT_VALID:"Der Benutzer ist ungültig. Versuchen Sie es mit den Anmeldeinformationen eines anderen Kontos.",
    VERIFIED:"Verifiziert",
    RESEND_VERIFICATION_MAIL:"Bestätigungsmail erneut senden",
    RETURN_TO_DASHBOARD:"Zurück zum Dashboard",
    ERROR_PAGE_BAD_REQUEST:"400 Ungültige Anfrage.",
    WASHES:"Anzahl der Wäschen",
    TIME_TO_SERVICE:"Zeit bis zur Wartung",
    ACCOUNT_ALREADY_ACTIVATED:"Konto bereits aktiviert",
    DEVICE_EVENTS:"Ereignisse",
    DEVICE_EVENTS_LOG_PULLED:"Ereignisprotokoll für das Gerät abgerufen",
    EVENTS_PULL_DATE:"Informationen angefordert am:",
    DEVICE_EVENTS_REFRESH:"Ereignisse aktualisieren",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Problem mit der WebSocket-Verbindung. Versuchen Sie, die Seite zu aktualisieren.",
    INSTALLATION_DATE:"Installationsdatum",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Heißwachs",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Hochdruckwäsche",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Powerfelgenschaum ",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Powerschaum",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Stopp",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Schaumwäsche",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Wäsche",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Top-Pflege",
    INFO_TITLE:"Info",
    FOAM_WAX1:"Schaumwachs",
    POLISH1:"Polish",
    WAX1:"Wachs",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Standortdetails erfolgreich aktualisiert",
    COMPANY:"Unternehmen",
    FACILITY_HAS_CHANGER:"Wechsler vorhanden?",
    DISABLE_OFFLINE_ALARM:"R2W-Alarme deaktivieren",
    ASIDE_WORKING_SCHEDULES:"App-Standortdetails",
    TERMS_OF_SERVICE_R2W_TITLE:"Ready2Wash-Nutzungsbedingungen",
    TERMS_OF_SERVICE_R2W:" Ready2Wash-Nutzungsbedingungen",
    DATA_PROCESSING_TITLE:"Daten verarbeitet",
    PRIVACY_POLICY_TITLE:"Datenschutzrichtlinie",
    READY_TO_PAY_TERMS_OF_SERVICE:"Ready2Pay-Nutzungsbedingungen",
    TERMS_AND_SERVICES:"Allgemeine Geschäftsbedingungen",
    HOURLY: "Stündlich",
    DAILY: "Täglich",
    WEEKLY: "Wöchentlich",
    MONTHLY: "Monatlich",
    YEARLY: "Jährlich",
    DELETE_ITEM_SUCCESS:"Sie haben das Element erfolgreich gelöscht",
    STATE: "Zustand",
    AVAILABILITY_STATUS_1: "Einheit geöffnet",
    AVAILABILITY_STATUS_2: "Einheit geschlossen (Feiertag)",
    AVAILABILITY_STATUS_3: "Einheit geschlossen (Betriebszeit)",
    AVAILABILITY_STATUS_4: "Einheit geschlossen (Störung)",
    AVAILABILITY_STATUS_5: "Einheit geschlossen (sonstiges)",
    AVAILABILITY_VACUUMS_STATUS_1: "Staubsauger nicht installiert",
    AVAILABILITY_VACUUMS_STATUS_2: "Staubsauger geöffnet",
    AVAILABILITY_VACUUMS_STATUS_3: "Staubsauger geschlossen (Feiertag)",
    AVAILABILITY_VACUUMS_STATUS_4: "Staubsauger geschlossen (Betriebszeit)",
    AVAILABILITY_VACUUMS_STATUS_5: "Staubsauger geschlossen (Störung)",
    AVAILABILITY_VACUUMS_STATUS_6: "Staubsauger geschlossen (sonstiges)",
    ECOM_AMOUNT: "Gesamt Ecom für alle Standorte",
    CAPTURED: "Erfasst",
    DELETE_COMPANY_HISTORY_INFO:"Diese Aktion löscht alle Berichtsdaten Ihres Unternehmens. Diese Aktion kann nicht rückgängig gemacht werden.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Sind Sie sicher, dass Sie alle Berichtsdaten dauerhaft löschen möchten?",
    VALUE_DATE: "Valutadatum",
    KARCHER_EVENT_NAME_1: "Grundwärmetauscher regeneriert",
    KARCHER_EVENT_NAME_2: "Regeneration des Grundwärmetauschers beendet",
    KARCHER_EVENT_NAME_3: "Material / Seriennummer",
    KARCHER_EVENT_NAME_4: "Das System wurde desinfiziert",
    KARCHER_EVENT_NAME_5: "HP-Pumpe 1 wurde desinfiziert",
    KARCHER_EVENT_NAME_6: "HP-Pumpe 2 wurde desinfiziert",
    KARCHER_EVENT_NAME_7: "HP-Pumpe 3 wurde desinfiziert",
    KARCHER_EVENT_NAME_8: "HP-Pumpe 4 wurde desinfiziert",
    KARCHER_EVENT_NAME_9: "HP-Pumpe 5 wurde desinfiziert",
    KARCHER_EVENT_NAME_10: "Waschanlage 1 gesperrt",
    KARCHER_EVENT_NAME_11: "Waschanlage 2 gesperrt",
    KARCHER_EVENT_NAME_12: "Waschanlage 3 gesperrt",
    KARCHER_EVENT_NAME_13: "Waschanlage 4 gesperrt",
    KARCHER_EVENT_NAME_14: "Waschanlage 5 gesperrt",
    KARCHER_EVENT_NAME_15: "Waschanlage 6 gesperrt",
    KARCHER_EVENT_NAME_16: "Waschanlage 7 gesperrt",
    KARCHER_EVENT_NAME_17: "Waschanlage 8 gesperrt",
    KARCHER_EVENT_NAME_18: "Update gestartet",
    KARCHER_EVENT_NAME_19: "Update abgeschlossen",
    KARCHER_EVENT_NAME_20: "WS Reg Start",
    KARCHER_EVENT_NAME_21: "WS Reg Ende",
    KARCHER_EVENT_NAME_22: "WS 75% Sensor",
    KARCHER_EVENT_NAME_23: "Technischer Defekt",
    KARCHER_EVENT_NAME_24: "Betriebsfehler",
    KARCHER_EVENT_NAME_25: "Einheit eingeschaltet",
    KARCHER_EVENT_NAME_26: "Einheit ausgeschaltet",
    KARCHER_EVENT_NAME_27: "Box 1 geschlossen",
    KARCHER_EVENT_NAME_28: "Box 2 geschlossen",
    KARCHER_EVENT_NAME_29: "Box 3 geschlossen",
    KARCHER_EVENT_NAME_30: "Box 4 geschlossen",
    KARCHER_EVENT_NAME_31: "Box 5 geschlossen",
    KARCHER_EVENT_NAME_32: "Box 6 geschlossen",
    KARCHER_EVENT_NAME_33: "Box 7 geschlossen",
    KARCHER_EVENT_NAME_34: "Box 8 geschlossen",
    KARCHER_EVENT_NAME_35: "HP-Pumpenstation 1",
    KARCHER_EVENT_NAME_36: "HP-Pumpenstation 2",
    KARCHER_EVENT_NAME_37: "HP-Pumpenstation 3",
    KARCHER_EVENT_NAME_38: "HP-Pumpenstation 4",
    KARCHER_EVENT_NAME_39: "HP-Pumpenstation 5",
    KARCHER_EVENT_NAME_40: "HP-Pumpenstation 6",
    KARCHER_EVENT_NAME_41: "HP-Pumpenstation 7",
    KARCHER_EVENT_NAME_42: "HP-Pumpenstation 8",
    KARCHER_EVENT_NAME_43: "Brenner",
    KARCHER_EVENT_NAME_44: "Brennerlüfter",
    KARCHER_EVENT_NAME_45: "Warmwasserpumpe",
    KARCHER_EVENT_NAME_46: "Frostschutzpumpe",
    KARCHER_EVENT_NAME_47: "Osmosepumpe",
    KARCHER_EVENT_NAME_48: "Fußbodenheizung",
    KARCHER_EVENT_NAME_49: "Schlauchheizung",
    KARCHER_EVENT_NAME_50: "Mikro-/Felgenreinigung",
    KARCHER_EVENT_NAME_51: "Unterbodenpumpe",
    KARCHER_EVENT_NAME_52: "Booster Pumpe Schaum",
    KARCHER_EVENT_NAME_53: "Staubsauger 1",
    KARCHER_EVENT_NAME_54: "Staubsauger 2",
    KARCHER_EVENT_NAME_55: "Staubsauger 3",
    KARCHER_EVENT_NAME_56: "Staubsauger 4",
    KARCHER_EVENT_NAME_57: "Staubsauger 5",
    KARCHER_EVENT_NAME_58: "Staubsauger 6",
    KARCHER_EVENT_NAME_59: "Staubsauger 7",
    KARCHER_EVENT_NAME_60: "Staubsauger 8",
    KARCHER_EVENT_NAME_61: "Staubsauger 9",
    KARCHER_EVENT_NAME_62: "Staubsauger 10",
    KARCHER_EVENT_NAME_63: "Staubsauger 11",
    KARCHER_EVENT_NAME_64: "Staubsauger 12",
    KARCHER_EVENT_NAME_65: "Felgenreinigungspumpe",
    KARCHER_EVENT_NAME_66: "Mikropumpe",
    KARCHER_EVENT_NAME_67: "Intensivpumpe",
    KARCHER_EVENT_NAME_68: "Turbine Staubsauger 1",
    KARCHER_EVENT_NAME_69: "Filter Staubsauger 1",
    KARCHER_EVENT_NAME_70: "Turbine Staubsauger 2",
    KARCHER_EVENT_NAME_71: "Filter Staubsauger 2",
    KARCHER_EVENT_NAME_72: "Turbine Staubsauger 3",
    KARCHER_EVENT_NAME_73: "Filter Staubsauger 3",
    KARCHER_EVENT_NAME_74: "Turbine Staubsauger 4",
    KARCHER_EVENT_NAME_75: "Filter Staubsauger 4",
    KARCHER_EVENT_NAME_76: "Turbine Staubsauger 5",
    KARCHER_EVENT_NAME_77: "Filter Staubsauger 5",
    KARCHER_EVENT_NAME_78: "Turbine Staubsauger 6",
    KARCHER_EVENT_NAME_79: "Filter Staubsauger 6",
    KARCHER_EVENT_NAME_80: "Turbine Staubsauger 7",
    KARCHER_EVENT_NAME_81: "Filter Staubsauger 7",
    KARCHER_EVENT_NAME_82: "Turbine Staubsauger 8",
    KARCHER_EVENT_NAME_83: "Filter Staubsauger 8",
    KARCHER_EVENT_NAME_84: "Turbine Staubsauger 9",
    KARCHER_EVENT_NAME_85: "Filter Staubsauger 9",
    KARCHER_EVENT_NAME_86: "Turbine Staubsauger 10",
    KARCHER_EVENT_NAME_87: "Filter Staubsauger 10",
    KARCHER_EVENT_NAME_88: "Turbine Staubsauger 11",
    KARCHER_EVENT_NAME_89: "Filter Staubsauger 11",
    KARCHER_EVENT_NAME_90: "Turbine Staubsauger 12",
    KARCHER_EVENT_NAME_91: "Filter Staubsauger 12",
    INSERT_TOKEN: "Token einfügen und Dienst starten",
    OPEN_SESSION: "Sitzung erfolgreich geöffnet",
    IN_PROGRESS: "In Bearbeitung ...",
    TOKEN_INSERTED: "Token erfolgreich eingefügt",
    EXPIRED_SESSION: "Sitzung abgelaufen",
    TWO_DIGIT_INTEGER_VALIDATION: "Verwenden Sie eine maximale zweistellige Ganzzahl",
    KARCHER_OPERATION_COUNTER_1: "Waschplatz 1 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_2: "Waschplatz 1 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_3: "Waschplatz 1 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_4: "Waschplatz 1 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_5: "Waschplatz 1 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_6: "Waschplatz 2 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_7: "Waschplatz 2 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_8: "Waschplatz 2 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_9: "Waschplatz 2 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_10: "Waschplatz 2 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_11: "Waschplatz 3 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_12: "Waschplatz 3 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_13: "Waschplatz 3 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_14: "Waschplatz 3 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_15: "Waschplatz 3 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_16: "Waschplatz 4 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_17: "Waschplatz 4 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_18: "Waschplatz 4 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_19: "Waschplatz 4 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_20: "Waschplatz 4 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_21: "Waschplatz 5 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_22: "Waschplatz 5 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_23: "Waschplatz 5 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_24: "Waschplatz 5 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_25: "Waschplatz 5 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_26: "Waschplatz 6 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_27: "Waschplatz 6 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_28: "Waschplatz 6 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_29: "Waschplatz 6 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_30: "Waschplatz 6 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_31: "Waschplatz 7 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_32: "Waschplatz 7 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_33: "Waschplatz 7 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_34: "Waschplatz 7 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_35: "Waschplatz 7 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_36: "Waschplatz 8 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_37: "Waschplatz 8 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_38: "Waschplatz 8 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_39: "Waschplatz 8 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_40: "Waschplatz 8 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_41: "Osmosepumpe",
    KARCHER_OPERATION_COUNTER_42: "Heißwassererzeuger",
    KARCHER_OPERATION_COUNTER_43: "Frostschutzpumpe",
    KARCHER_OPERATION_COUNTER_44: "Filtereinsatz WSO",
    KARCHER_OPERATION_COUNTER_45: "Pumpe Waschplatzheizung",
    KARCHER_OPERATION_COUNTER_46: "Warmwasserpumpe",
    KARCHER_OPERATION_COUNTER_47: "Schaumschlauchheizung",
    KARCHER_OPERATION_COUNTER_48: "Pumpe Felgenreinigung",
    KARCHER_OPERATION_COUNTER_49: "Pumpe Micro-Emulsion",
    KARCHER_OPERATION_COUNTER_50: "Pumpe Intensivschaum",
    KARCHER_OPERATION_COUNTER_51: "Sauger 1 Turbine 1",
    KARCHER_OPERATION_COUNTER_52: "Sauger 1 Filter 1",
    KARCHER_OPERATION_COUNTER_53: "Sauger 1 Turbine 2",
    KARCHER_OPERATION_COUNTER_54: "Sauger 1 Filter 2",
    KARCHER_OPERATION_COUNTER_55: "Sauger 2 Turbine 1",
    KARCHER_OPERATION_COUNTER_56: "Sauger 2 Filter 1",
    KARCHER_OPERATION_COUNTER_57: "Sauger 2 Turbine 2",
    KARCHER_OPERATION_COUNTER_58: "Sauger 2 Filter 2",
    KARCHER_OPERATION_COUNTER_59: "Sauger 3 Turbine 1",
    KARCHER_OPERATION_COUNTER_60: "Sauger 3 Filter 1",
    KARCHER_OPERATION_COUNTER_61: "Sauger 3 Turbine 2",
    KARCHER_OPERATION_COUNTER_62: "Sauger 3 Filter 2",
    KARCHER_OPERATION_COUNTER_63: "Sauger 4 Turbine 1",
    KARCHER_OPERATION_COUNTER_64: "Sauger 4 Filter 1",
    KARCHER_OPERATION_COUNTER_65: "Sauger 4 Turbine 2",
    KARCHER_OPERATION_COUNTER_66: "Sauger 4 Filter 2",
    KARCHER_OPERATION_COUNTER_67: "Sauger 5 Turbine 1",
    KARCHER_OPERATION_COUNTER_68: "Sauger 5 Filter 1",
    KARCHER_OPERATION_COUNTER_69: "Sauger 5 Turbine 2",
    KARCHER_OPERATION_COUNTER_70: "Sauger 5 Filter 2",
    KARCHER_OPERATION_COUNTER_71: "Sauger 6 Turbine 1",
    KARCHER_OPERATION_COUNTER_72: "Sauger 6 Filter 1",
    KARCHER_OPERATION_COUNTER_73: "Sauger 6 Turbine 2",
    KARCHER_OPERATION_COUNTER_74: "Sauger 6 Filter 2",
    KARCHER_OPERATION_COUNTER_75: "Kondenswasser am Kompressor ablassen",
    KARCHER_OPERATION_COUNTER_76: "Frostschutzsystem überprüfen",
    KARCHER_OPERATION_COUNTER_77: "Brennergebläse",
    KARCHER_OPERATION_COUNTER_78: "Druckerhöhung Schaum",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Datenliste ist größer als 10000 Einträge",
    KARCHER_POINT_NAME_1: "Feiertag",
    KARCHER_POINT_NAME_2: "Montag",
    KARCHER_POINT_NAME_3: "Dienstag",
    KARCHER_POINT_NAME_4: "Mittwoch",
    KARCHER_POINT_NAME_5: "Donnerstag",
    KARCHER_POINT_NAME_6: "Freitag",
    KARCHER_POINT_NAME_7: "Samstag",
    KARCHER_POINT_NAME_8: "Sonntag",
    KARCHER_POINT_NAME_9: "Staubsauger Feiertag",
    KARCHER_POINT_NAME_10: "Staubsauger Montag",
    KARCHER_POINT_NAME_11: "Staubsauger Dienstag",
    KARCHER_POINT_NAME_12: "Staubsauger Mittwoch",
    KARCHER_POINT_NAME_13: "Staubsauger Donnerstag",
    KARCHER_POINT_NAME_14: "Staubsauger Freitag",
    KARCHER_POINT_NAME_15: "Staubsauger Samstag",
    KARCHER_POINT_NAME_16: "Staubsauger Sonntag",
    KARCHER_POINT_NAME_17: "Beleuchtung Feiertag",
    KARCHER_POINT_NAME_18: "Beleuchtung Montag",
    KARCHER_POINT_NAME_19: "Beleuchtung Dienstag",
    KARCHER_POINT_NAME_20: "Beleuchtung Mittwoch",
    KARCHER_POINT_NAME_21: "Beleuchtung Donnerstag",
    KARCHER_POINT_NAME_22: "Beleuchtung Freitag",
    KARCHER_POINT_NAME_23: "Beleuchtung Samstag",
    KARCHER_POINT_NAME_24: "Beleuchtung Sonntag",
    KARCHER_POINT_NAME_25: "Programm 0",
    KARCHER_POINT_NAME_26: "Programm 1",
    KARCHER_POINT_NAME_27: "Programm 2",
    KARCHER_POINT_NAME_28: "Programm 3",
    KARCHER_POINT_NAME_29: "Programm 4",
    KARCHER_POINT_NAME_30: "Programm 5",
    KARCHER_POINT_NAME_31: "Programm 6",
    KARCHER_POINT_NAME_32: "Programm 7",
    KARCHER_POINT_NAME_33: "Programm 8",
    KARCHER_POINT_NAME_34: "Programm 9",
    KARCHER_POINT_NAME_35: "Programm 10",
    KARCHER_POINT_NAME_36: "Programm 11",
    KARCHER_POINT_NAME_37: "Programm 12",
    KARCHER_POINT_NAME_38: "Programm 13",
    KARCHER_POINT_NAME_39: "Programm 14",
    KARCHER_POINT_NAME_40: "Programm 15",
    KARCHER_POINT_NAME_41: "Programm 16",
    KARCHER_POINT_NAME_42: "Programm 17",
    KARCHER_POINT_NAME_43: "Programm 18",
    KARCHER_POINT_NAME_44: "Programm 19",
    KARCHER_POINT_NAME_45: "Programm 20",
    KARCHER_POINT_NAME_46: "Programm 21",
    KARCHER_POINT_NAME_47: "Programm 22",
    KARCHER_POINT_NAME_48: "Programm 23",
    KARCHER_POINT_NAME_49: "Programm 24",
    KARCHER_POINT_NAME_50: "Programm 25",
    KARCHER_POINT_NAME_51: "Programm 26",
    KARCHER_POINT_NAME_52: "Programm 27",
    KARCHER_POINT_NAME_53: "Programm 28",
    KARCHER_POINT_NAME_54: "Programm 29",
    KARCHER_POINT_NAME_55: "Programm 30",
    KARCHER_POINT_NAME_56: "Programm 31",
    KARCHER_POINT_NAME_57: "Programm 32",
    QR_CODE: "QR-Code",
    ACCEPT_TERMS_AND_CONDITIONS: "Geschäftsbedingungen akzeptieren",
    CREATE_AND_PRINT_VOUCHERS: "Gutscheine erstellen und drucken",
    CREATE_AND_PRINT_VOUCHERS_VACC: "Gutscheine erstellen und drucken - VACC",
    CODE_PREFIX_QUESTION: "Präfixcode ist nicht eingegeben",
    CODE_PREFIX_QUESTION_TEXT: "Möchten Sie ohne Präfixcode fortfahren?",
    ISSUED_DATE: "Ausstellungsdatum",
    VOUCHER_VALIDITY_DAYS: "Gutscheingültigkeit (Tage)",
    VALIDATION_ONLY_NUMBERS: "Nur Zahlen sind erlaubt",
    REPRINT_VOUCHERS: "Kopie der Gutscheine drucken",
    EXPIRY_DATE: "Gültig bis",
    ROLLOVER_SALES_TYPES: "Verkaufstypen",
    ROLLOVER_SALES_TYPE_ACTIVE: "Aktiv",
    ROLLOVER_SALES_TYPE_UPDATED: "Verkaufstyp erfolgreich aktualisiert",
    ROLLOVER_NO_SALES_TYPES: "Keine Verkaufstypen verfügbar",
    ROLLOVER_ZERO_PRICE: "Nullpreis",
    ROLLOVER_SPECIAL_OFFER_PRICES: "Sonderangebotspreise",
    ROLLOVER_UNLIMITED_WASHES: "Unbegrenzte Wäschen",
    ACTIVE: "Aktiv",
    INACTIVE: "Inaktiv",
    SUCCESS: "Erfolg",
    ASIDE_MENU_SAVINGS: "Sparen",
    SAVINGS_SEARCH_PLACEHOLDER: "Nach Benutzer-ID oder Unternehmen suchen",
    SAVINGS_USERS_LIST: "Sparnutzer",
    SAVINGS_NO_USERS: "Keine Sparnutzer gefunden",
    SAVINGS_USER_ID: "Benutzer-ID (GUID)",
    SAVINGS_COMPANY: "Unternehmen",
    SAVINGS_BALANCE: "Kontostand",
    SAVINGS_STATUS: "Status",
    SAVINGS_EXPIRATION_DATE: "Ablaufdatum",
    SAVINGS_ACTIONS: "Aktionen",
    SAVINGS_DEACTIVATE: "Deaktivieren",
    SAVINGS_DEACTIVATE_TITLE: "Sparkonto deaktivieren",
    SAVINGS_DEACTIVATE_MESSAGE: "Sind Sie sicher, dass Sie dieses Sparkonto deaktivieren möchten?",
    SAVINGS_PACKAGES: "Sparpakete",
    SAVINGS_CREDIT_AMOUNT: "Kreditbetrag"
  });
})();
